/* ============================================================
   ATELIER PROJECT STUDIO  (/pages/project)
   localStorage renovation planner. Real products via the Section
   Rendering API (sections/atelier-project-picker.liquid) against
   real category collections. Opens the existing Atelier cart drawer.
   Ported from _bsd-atelier-project-studio-harness.html.
   ============================================================ */
(function(){
  "use strict";
  var DATA = window.PS_DATA || { routes:{ root:"/", cartAdd:"/cart/add" }, counts:{} };
  var ROOT = DATA.routes.root || "/"; if (ROOT.charAt(ROOT.length-1) !== "/") ROOT += "/";
  var CART_ADD = (DATA.routes.cartAdd || "/cart/add") + ".js";
  var COUNTS = DATA.counts || {};
  var LS_KEY = "atelierProject";
  /* brand directory (name -> logo) for the room-level brand lock chooser */
  var BRANDS = DATA.brands || [];
  var BRAND_LOGO = {}; BRANDS.forEach(function(b){ if(b && b.n) BRAND_LOGO[b.n]=b.l||""; });
  /* Two logo types (classified by background brightness of the source asset):
     - dark-bg "branded tiles" (their dark bg IS the swatch) -> COVER, fill the box.
     - white-bg marks -> CONTAIN; these use margin-trimmed theme assets so they fill nicely.
     Keyed by lowercase brand-name substring (works off brand_name, not a collection handle). */
  /* Fienza/Ikon/Nero moved to contain when they switched from dark tiles to
     trimmed SVG wordmarks (atelier-brand-*.svg via the atelier-brand-logo snippet).
     ART Australia (wide lockup) + Modern National (monogram) joined them 2026-07-06
     once they gained real vectors - cover would crop them, so every brand is contain. */
  var BRAND_COVER = [];
  function brandFit(name){ var n=(name||"").toLowerCase(); for(var i=0;i<BRAND_COVER.length;i++){ if(n.indexOf(BRAND_COVER[i])>=0) return "cover"; } return "contain"; }
  function brandImgStyle(name){ var f=brandFit(name); return "object-fit:"+f+(f==="contain"?";padding:2px":""); }

  /* ---------- helpers ---------- */
  var $ = function(s,r){ return (r||document).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  function money(cents){ return "$" + Math.round((cents||0)/100).toLocaleString("en-AU"); }
  function moneyExact(cents){ return "$" + ((cents||0)/100).toLocaleString("en-AU",{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function finSlug(name){ return (name||"").toLowerCase().replace(/\//g,"-").replace(/\s+/g,"-"); }
  function swSlug(slug){ return '<span class="sw sw-metal sw--'+(slug||"")+'"></span>'; }
  /* swatch by FINISH NAME - always render the family gradient. Raw product names
     ("Gunmetal Grey", "PVD Brushed Gold") have no swatch of their own, so map to family. */
  function SW(name){ return swSlug(family(name)||finSlug(name)); }
  /* friendly display name for a family slug (Brushed Gold, Gunmetal, …) */
  function famLabel(fam){
    for(var i=0;i<FAMILIES.length;i++){ if(finSlug(FAMILIES[i])===fam) return FAMILIES[i]; }
    return fam ? fam.replace(/-/g," ").replace(/\b\w/g,function(c){return c.toUpperCase();}) : "Other";
  }
  /* show an item's finish as its FAMILY name - consolidates messy per-product
     names (Urban Brass / PVD Brushed Gold -> Brushed Gold); raw name if unknown. */
  function finishDisplay(name){ var f=family(name); return f?famLabel(f):name; }
  function esc(s){ return (s||"").replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];}); }

  /* finish-family resolver — mirrors snippets/atelier-finish-family.liquid */
  function family(finish){
    if(!finish) return "";
    var f = finish.toLowerCase().trim(), slug = finSlug(finish);
    var known = "|matte-black|matte-white|chrome|brushed-nickel|warm-brushed-nickel|brushed-gold|gunmetal|brushed-bronze|brushed-copper|champagne|antique-brass|stainless-steel|";
    if(known.indexOf("|"+slug+"|")>=0) return slug;
    if(f.indexOf("champagne")>=0) return "champagne";
    if(f.indexOf("tiger bronze")>=0) return "brushed-gold";
    if(f.indexOf("lustre bronze")>=0||f.indexOf("bronze copper")>=0) return "brushed-copper";
    if(f.indexOf("gold")>=0||f.indexOf("brass")>=0) return "brushed-gold";
    if(f.indexOf("gunmetal")>=0||f.indexOf("gun metal")>=0||f.indexOf("shadow")>=0) return "gunmetal";
    if(f.indexOf("copper")>=0) return "brushed-copper";
    if(f.indexOf("bronze")>=0) return "brushed-bronze";
    if(f.indexOf("warm")>=0 && f.indexOf("nickel")>=0) return "warm-brushed-nickel";
    if(f.indexOf("nickel")>=0) return "brushed-nickel";
    if(f.indexOf("chrome")>=0) return "chrome";
    if(f.indexOf("stainless")>=0||f.indexOf("steel")>=0) return "stainless-steel";
    if(f.indexOf("white")>=0) return "matte-white";
    if(f.indexOf("black")>=0) return "matte-black";
    return "";
  }

  /* ---------- config ---------- */
  /* fixture icons — Material Design Icons (filled, viewBox 0 0 24 24), professionally drawn.
     Shared ones (mixer/sink/accessory) are referenced by multiple slots so they stay in sync. */
  var IC = {
    toilet:   '<path d="M9,22H17V19.5C19.41,17.87 21,15.12 21,12V4A2,2 0 0,0 19,2H15C13.89,2 13,2.9 13,4V12H3C3,15.09 5,18 9,19.5V22Z"/>',
    vanity:   '<rect x="2.6" y="8.6" width="18.8" height="2" rx="1"/><path d="M6 4.3h12a6 4.3 0 0 1-12 0z"/><path fill-rule="evenodd" d="M4.5 10.4h15a1.5 1.5 0 0 1 1.5 1.5v7.1a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-7.1a1.5 1.5 0 0 1 1.5-1.5zM11.6 12h.8v6.6h-.8zM8.5 14.7h1.4v2H8.5zM14.1 14.7h1.4v2h-1.4z"/>',
    basin:    '<path d="M22 15C22 18.9 18.9 22 15 22H9C5.1 22 2 18.9 2 15V12H22V15Z"/>',
    mixer:    '<path d="M19 14V16H16V14.28L19 14M19 13C19 11.9 18 11 16.8 11H10V10H5V21H10V13.91L19 13M5 9H10V7L15.36 5.21C15.74 5.09 16 4.73 16 4.33C16 3.68 15.36 3.23 14.75 3.45L5 7V9Z"/>',
    /* shower wall mixer: round escutcheon plate + long downward outlet (same MDI 24 filled style) */
    showermixer:'<circle cx="12" cy="10" r="5.5"/><rect x="10.8" y="14" width="2.4" height="8" rx="1.2"/>',
    shower:   '<path d="M20,20A1,1 0 0,1 21,21A1,1 0 0,1 20,22A1,1 0 0,1 19,21A1,1 0 0,1 20,20M16,20A1,1 0 0,1 17,21A1,1 0 0,1 16,22A1,1 0 0,1 15,21A1,1 0 0,1 16,20M12,20A1,1 0 0,1 13,21A1,1 0 0,1 12,22A1,1 0 0,1 11,21A1,1 0 0,1 12,20M8,20A1,1 0 0,1 9,21A1,1 0 0,1 8,22A1,1 0 0,1 7,21A1,1 0 0,1 8,20M4,20A1,1 0 0,1 5,21A1,1 0 0,1 4,22A1,1 0 0,1 3,21A1,1 0 0,1 4,20M6,17A1,1 0 0,1 7,18A1,1 0 0,1 6,19H6A1,1 0 0,1 5,18A1,1 0 0,1 6,17H6M10,17A1,1 0 0,1 11,18A1,1 0 0,1 10,19A1,1 0 0,1 9,18A1,1 0 0,1 10,17M14,17A1,1 0 0,1 15,18A1,1 0 0,1 14,19A1,1 0 0,1 13,18A1,1 0 0,1 14,17M18,17A1,1 0 0,1 19,18A1,1 0 0,1 18,19A1,1 0 0,1 17,18A1,1 0 0,1 18,17M8,14A1,1 0 0,1 9,15A1,1 0 0,1 8,16A1,1 0 0,1 7,15A1,1 0 0,1 8,14M12,14A1,1 0 0,1 13,15A1,1 0 0,1 12,16A1,1 0 0,1 11,15A1,1 0 0,1 12,14M16,14A1,1 0 0,1 17,15A1,1 0 0,1 16,16A1,1 0 0,1 15,15A1,1 0 0,1 16,14M19,12H5V10H19V12M17.92,9H6.08C6.5,6.5 8.5,4.5 11,4.08V2H13V4.08C15.5,4.5 17.5,6.5 17.92,9Z"/>',
    bath:     '<path d="M7 5C8.11 5 9 5.9 9 7S8.11 9 7 9 5 8.11 5 7 5.9 5 7 5M20 13V4.83C20 3.27 18.73 2 17.17 2C16.42 2 15.7 2.3 15.17 2.83L13.92 4.08C13.76 4.03 13.59 4 13.41 4C13 4 12.64 4.12 12.33 4.32L15.09 7.08C15.29 6.77 15.41 6.4 15.41 6C15.41 5.82 15.38 5.66 15.34 5.5L16.59 4.24C16.74 4.09 16.95 4 17.17 4C17.63 4 18 4.37 18 4.83V13H11.15C10.85 12.79 10.58 12.55 10.33 12.28L8.93 10.73C8.74 10.5 8.5 10.35 8.24 10.23C7.93 10.08 7.59 10 7.24 10C6 10 5 11 5 12.25V13H2V19C2 20.1 2.9 21 4 21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21C21.1 21 22 20.1 22 19V13H20Z"/>',
    towel:    '<g transform="scale(.09375)"><path d="M224 48v104a8 8 0 0 1-8.53 8a8.17 8.17 0 0 1-7.47-8.25V48a8 8 0 0 0-8.55-8a8.19 8.19 0 0 0-7.45 8.28V180a4 4 0 0 1-4 4H52a4 4 0 0 1-4-4V48a24 24 0 0 1 24-24h128a24 24 0 0 1 24 24m-36 152H52a4 4 0 0 0-4 4v12a16 16 0 0 0 16 16h112a16 16 0 0 0 16-16v-12a4 4 0 0 0-4-4"/></g>',
    mirror:   '<path d="M12 1C16.69 1 20.5 5.93 20.5 12C20.5 18.08 16.69 23 12 23C7.31 23 3.5 18.08 3.5 12C3.5 5.93 7.31 1 12 1M12 3C8.41 3 5.5 7.03 5.5 12C5.5 16.97 8.41 21 12 21C15.59 21 18.5 16.97 18.5 12C18.5 7.03 15.59 3 12 3M8.29 10.28L11.53 7.03L12.59 8.09L9.35 11.34L8.29 10.28M8.7 14.61L14.36 8.95L15.42 10L9.76 15.67L8.7 14.61Z"/>',
    accessory:'<path d="M3 5h11.5a1.1 1.1 0 0 1 0 2.2H5.2V12a1.1 1.1 0 0 1-2.2 0z"/><path fill-rule="evenodd" d="M6.2 12.5a4.6 4.6 0 1 0 9.2 0 4.6 4.6 0 1 0-9.2 0M9.2 12.5a1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 1 0-3.2 0"/>',
    sink:     '<path d="M22 15C22 18.9 18.9 22 15 22H9C5.1 22 2 18.9 2 15V12H22V15Z"/>'
  };
  /* SLOT -> real category collection + sub-collection chips (real handles).
     fin = finish-bearing (drives coordination). ess = essential (counts toward progress). */
  var SLOTS = {
    toilet:      {label:"Toilet suite", coll:"toilet-suites", ess:true, fin:false, ic:IC.toilet,
      subs:[{n:"Wall-Faced",coll:"wall-faced-pans"},{n:"Back-to-Wall",coll:"back-to-wall-toilet-suites"},{n:"Wall-Hung",coll:"wall-hung-pans"},{n:"In-Wall",coll:"in-wall-toilet-packages"}]},
    vanity:      {label:"Vanity", coll:"bathroom-vanities", ess:true, fin:false, ic:IC.vanity,
      subs:[{n:"Wall-Hung",coll:"wall-hung-vanities"},{n:"On Legs",coll:"vanities-on-legs"},{n:"On Kickboard",coll:"vanities-on-kickboard"}]},
    basin:       {label:"Basin", coll:"basins", ess:false, fin:false, hint:"Only if your vanity doesn't include a moulded top or basin", ic:IC.basin,
      subs:[{n:"Above-Counter",coll:"counter-top-basins"},{n:"Semi-Inset",coll:"semi-inset-basins"},{n:"Under-Counter",coll:"under-basins"},{n:"Wall-Hung",coll:"wall-hung-basins"},{n:"Freestanding",coll:"freestanding-basins"}]},
    "basin-mixer":{label:"Basin mixer", coll:"basin-mixers", ess:true, fin:true, ic:IC.mixer,
      subs:[{n:"Tall",coll:"tall-basin-mixers"},{n:"Wall-Mounted",coll:"wall-basin-mixers"}]},
    shower:      {label:"Shower", coll:"showers", ess:true, fin:true, ic:IC.shower,
      subs:[{n:"On Rail",coll:"shower-on-rail"},{n:"Shower Heads",coll:"shower-heads"},{n:"Twin",coll:"twin-showers"},{n:"Multifunction",coll:"shower-column-set"},{n:"Arms",coll:"shower-arms"}]},
    "shower-mixer":{label:"Shower mixer", coll:"shower-wall-mixers", ess:true, fin:true, ic:IC.showermixer,
      subs:[{n:"With Diverter",coll:"shower-mixers-diverter"}]},
    bath:        {label:"Bath", coll:"bathtubs", ess:false, fin:false, ic:IC.bath, subs:[]},
    /* no collection/tag isolates rail vs hand-towel rail — only the title does, so those two
       are keyword sub-filters (kw) on the base collection; Heated/Rings switch collection. */
    "towel-rail":{label:"Towel rail", coll:"towel-bar-rails", ess:true, fin:true, ic:IC.towel,
      subs:[{n:"Towel Rail",kw:"!hand"},{n:"Hand Towel",kw:"hand"},{n:"Heated",coll:"heated-rails"},{n:"Towel Rings",coll:"towel-rings"}]},
    mirror:      {label:"Mirror", coll:"bathroom-mirrors", ess:true, fin:false, ic:IC.mirror,
      subs:[{n:"LED",coll:"led-mirrors"},{n:"Shaving Cabinets",coll:"shaving-cabinets"}]},
    accessory:   {label:"Accessories", coll:"bathroom-accessories", ess:false, fin:true, multi:true, ic:IC.accessory,
      subs:[{n:"Towel Rings",coll:"towel-rings"},{n:"Paper Holders",coll:"paper-holders"}]},
    /* --- kitchen / laundry slots (real kitchen & laundry collections, not bathroom) --- */
    sink:        {label:"Kitchen sink", coll:"single-bowls", ess:true, fin:false, subAllLabel:"Single bowl", ic:IC.sink,
      subs:[{n:"Double Bowl",coll:"double-bowls"},{n:"Granite",coll:"granite-sinks"},{n:"Butler",coll:"butlers-ceramic-sink"}]},
    "kitchen-mixer":{label:"Kitchen mixer", coll:"kitchen-mixers", ess:true, fin:true, ic:IC.mixer,
      subs:[{n:"Pull-Out",coll:"pull-out-kitchen-mixers"}]},
    "kitchen-accessory":{label:"Sink accessories", coll:"sink-accessories", ess:false, fin:false, multi:true, ic:IC.accessory, subs:[]},
    "laundry-sink":{label:"Laundry tub / sink", coll:"laundry-and-butler-sinks", ess:true, fin:false, ic:IC.sink,
      subs:[{n:"Laundry Tubs",coll:"laundry-tubs"},{n:"Butler",coll:"butlers-ceramic-sink"}]},
    "laundry-mixer":{label:"Laundry mixer", coll:"laundry-mixers", ess:true, fin:true, ic:IC.mixer, subs:[]}
  };
  var ROOMS = {
    ensuite: {name:"Ensuite", icon:'<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18M8 4v6"/>', desc:"Compact second bathroom — toilet, vanity, shower and the essentials.", slots:["toilet","vanity","basin","basin-mixer","shower","shower-mixer","towel-rail","mirror","accessory"]},
    main:    {name:"Main Bathroom", icon:'<path d="M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"/><path d="M7 12V7a2 2 0 0 1 2-2 2 2 0 0 1 2 2"/>', desc:"The full family bathroom — add a bath alongside the shower.", slots:["toilet","vanity","basin","basin-mixer","shower","shower-mixer","bath","towel-rail","mirror","accessory"]},
    laundry: {name:"Laundry", icon:'<rect x="4" y="3" width="16" height="18" rx="2"/><circle cx="12" cy="13" r="4"/><path d="M7 6h.01M10 6h.01"/>', desc:"Tub or sink, a mixer and the bits to finish the wet areas.", slots:["laundry-sink","laundry-mixer","kitchen-accessory"]},
    kitchen: {name:"Kitchen", icon:'<path d="M4 9h16v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"/><path d="M8 9V5a3 3 0 0 1 6 0M17 4v5"/>', desc:"A sink, a mixer to match your tapware, and the finishing pieces.", slots:["sink","kitchen-mixer","kitchen-accessory"]}
  };
  /* When the Vanity Builder is enabled, surface a "Vanity Builder" tab in the
     Vanity picker (hooks the real vanity-builder collection — all configurable).
     Gated so it never appears on themes with the builder off. */
  if(DATA.vbEnabled && SLOTS.vanity){
    SLOTS.vanity.subs = [{n:"Vanity Builder", coll:"vanity-builder"}].concat(SLOTS.vanity.subs||[]);
  }
  var FAMILIES = ["Matte Black","Matte White","Chrome","Brushed Nickel","Warm Brushed Nickel","Brushed Gold","Gunmetal","Brushed Bronze","Brushed Copper","Champagne"];
  /* popular finish quick-starts (start screen) */
  var STARTS = ["Matte Black","Warm Brushed Nickel","Brushed Gold","Chrome"];
  /* order the configured-vanity spec rows are shown in (label = the cart's
     line-item property key, so it reads exactly like the cart). */
  var VB_SPEC_ORDER = ["Size","Tier","Door Configuration","Style","Cabinet Finish","Top","Benchtop","Benchtop Thickness","Handle","Taphole","Taphole (Left)","Taphole (Right)","Door Hinge","Basin"];
  /* the configured vanity stores the builder's bundle; the labelled details are
     the vanity line's line-item properties — the SAME data the cart shows.
     Prefer the captured `specs`; otherwise rebuild them from the bundle (so
     vanities configured before specs existed still show labels). */
  function vbSpecs(it){
    if(it.specs && it.specs.length) return it.specs;
    var vp=(it.bundle && it.bundle[0] && it.bundle[0].properties) || {};
    // value -> label map from the vanity line's customer-facing properties
    var v2k={};
    Object.keys(vp).forEach(function(k){
      if(k.charAt(0)==="_" || k==="Added with") return;
      var val=String(vp[k]).trim(); v2k[val]=k;
      var tail=val.split(" - ").pop().trim();           // "Cherry Pie - Pepper Mill" -> "Pepper Mill"
      if(tail && !v2k[tail]) v2k[tail]=k;
    });
    var parts=(it.config||"").split(" · ").map(function(s){return s.trim();}).filter(Boolean);
    if(parts.length){ var sawSize=false; return parts.map(function(p){
      if(v2k[p]) return {k:v2k[p], v:p};                 // labelled from a real property
      if(/^\d+\s*mm$/i.test(p)){ if(!sawSize){ sawSize=true; return {k:"Size", v:p}; } return {k:"Benchtop Thickness", v:p}; }
      return {k:"Basin", v:p};                           // remaining = the chosen basin
    }); }
    return Object.keys(vp).filter(function(k){return k.charAt(0)!=="_"&&k!=="Added with";}).map(function(k){return {k:k, v:String(vp[k])};});
  }

  /* ---------- state ----------
     A WORKSPACE holds several named PROJECTS; each project holds rooms (as before).
     `project` is a live pointer to the active project, so the rest of the app is
     unchanged - it just mutates project.rooms in place and save() persists the lot. */
  var WS_KEY = "atelierWorkspace";
  /* stable slot order -> a 1-char code in share links (instead of the full slot string).
     APPEND ONLY: never reorder or remove, or existing links break. */
  var SLOT_CODES = ["toilet","vanity","basin","basin-mixer","shower","shower-mixer","bath","towel-rail","mirror","accessory","sink","kitchen-mixer","kitchen-accessory","laundry-sink","laundry-mixer"];
  var workspace = { projects:[], active:0 };
  var project = { rooms:[], active:0 };
  var picker = { slot:null, coll:null, coordOn:true, dom:null, nodes:[], nextPage:null, loading:false };
  var fstepCtx = { type:null, sel:null, mode:"new" };
  var sugCache = {}; // coll -> {nodes:[],done:true}
  var sharedMode = false;   // viewing a shared link (never persists until claimed)
  var wantSlotsEnter = false; // animate the slot cards in on the NEXT render (board entry only)
  var vbView = false;       // the inline Vanity Builder view is open

  function pid(){ return "p"+Date.now().toString(36)+Math.random().toString(36).slice(2,6); }
  function blankProject(name){ return { id:pid(), name:name||"My project", rooms:[], active:0 }; }
  /* auto-number a default name so new projects don't pile up as identical "My project"s
     (user renames may still collide by choice - we only de-dupe the auto default) */
  function uniqueName(base){
    var used={}; workspace.projects.forEach(function(p){ used[p.name]=1; });
    if(!used[base]) return base;
    var n=2; while(used[base+" "+n]) n++; return base+" "+n;
  }
  function activeProject(){ return workspace.projects[workspace.active]; }
  function activeRoom(){ return project.rooms[project.active]; }
  function persist(){ try{ localStorage.setItem(WS_KEY, JSON.stringify(workspace)); }catch(e){} }
  function save(){ if(sharedMode) return; persist(); updateBadge(); renderProjUI(); }
  function load(){
    try{
      var raw=localStorage.getItem(WS_KEY);
      if(raw){ var w=JSON.parse(raw); if(w&&w.projects&&w.projects.length){ workspace=w; } }
      else {
        // migrate the old single-project key (atelierProject) -> one named project
        var oldRaw=localStorage.getItem(LS_KEY);
        if(oldRaw){ var d=JSON.parse(oldRaw); if(d&&d.rooms){ workspace={ projects:[ {id:pid(),name:"My project",rooms:d.rooms,active:d.active||0} ], active:0 }; persist(); } }
      }
    }catch(e){}
    if(!workspace.projects||!workspace.projects.length){ workspace={ projects:[ blankProject() ], active:0 }; }
    if(workspace.active>=workspace.projects.length) workspace.active=0;
    workspace.projects.forEach(function(p){ if(!p.rooms) p.rooms=[]; if(!p.id) p.id=pid(); if(!p.name) p.name="My project"; if(p.active>=p.rooms.length) p.active=0; });
    project = activeProject();
  }
  function updateBadge(){
    var n = project.rooms.reduce(function(a,r){return a+r.items.length;},0);
    var b = document.getElementById("psNavBadge");
    if(b){ if(n>0){ b.textContent=n; b.hidden=false; } else { b.hidden=true; } }
  }
  /* ---------- projects (workspace) ---------- */
  function newProject(){
    if(sharedMode) return;
    var p=blankProject(uniqueName("My project")); workspace.projects.push(p); workspace.active=workspace.projects.length-1; project=p;
    closeProjMenu(); persist(); updateBadge(); showStart(); renderProjUI();
  }
  function switchProject(idx){
    if(sharedMode||idx<0||idx>=workspace.projects.length) return;
    workspace.active=idx; project=activeProject(); persist(); closeProjMenu();
    if(project.rooms.length){ showBoard(); } else { showStart(); }
    renderProjUI();
  }
  function deleteProject(idx){
    if(sharedMode||workspace.projects.length<=1) return;
    workspace.projects.splice(idx,1);
    if(workspace.active>=workspace.projects.length) workspace.active=workspace.projects.length-1;
    else if(idx<workspace.active) workspace.active--;
    project=activeProject(); persist(); updateBadge();
    if(project.rooms.length){ showBoard(); } else { showStart(); }
    renderProjUI();
  }
  function renameActiveProject(name){ if(name){ activeProject().name=name; save(); } }

  /* cache DOM refs */
  var el = {};
  function ref(){
    ["psStart","psBoard","psVbView","psVbHost","psVbTitle","psVbBack","psRoomPick","psSuiteChips","psRtabs","psStartOver","psRoomName","psRenameBtn","psDupBtn","psDelBtn","psSpec",
     "psProjbar","psProjName","psProjRename","psProjMenuBtn","psProjMenu","psProjList","psProjNew","psProjSave","psProjMenuSave",
     "psSaveTip","psSaveTipGo","psSaveTipX",
     "psProgBar","psProgTxt","psRfinBtn","psRfinSw","psRfinLab","psRbrandBtn","psRbrandLogo","psRbrandLab","psItemCt","psSlots",
     "psPkBrands","psPkBrandsStrip","psBrandStep","psBrandStepTitle","psBrandSearch","psBrandGrid","psBrandSkip","psBrandGo",
     "psSuggest","psSuggestTitle","psSuggestSub","psSuggestRail","psSuggestAll",
     "psFschedTitle","psFschedChips","psFschedEmpty","psFschedNudge","psNudgeTx",
     "psSubLabel","psSubVal","psSaveRow","psSaveVal","psTotalVal","psAddRoom","psEnquire","psShare",
     "psBudget","psBudgetAdd","psBudgetOn","psBudgetFill","psBudgetStatus","psBudgetEdit",
     "psRecap","psRecapRows","psRecapTot","psRecapBudget","psRecapBudgetVal","psAddAll",
     "psBar","psBarTotal","psBarAdd","psBarExpand","psSheetScrim","psSheetClose",
     "psScrim","psPicker","psPkEyebrow","psPkTitle","psPkClose","psPkSearch","psPkCoord","psPkCoordSw","psPkCoordTx","psPkCoordTog","psPkSubs","psPkCount","psPkGrid","psPkView",
     "psFstep","psFstepEyebrow","psFstepTitle","psFstepGrid","psFstepGo","psFstepSkip",
     "psVariantStep","psVstepTitle","psVstepProd","psVstepList","psVstepGo","psVstepCancel",
     "psSharedBar","psSharedAdd","psSharedReplace","psSharedDiscard",
     "psShareModal","psShareX","psShareLink","psShareCopy","psShareEmail","psShareWa",
     "psEnquireModal","psEnqX","psEnqForm","psEnqName","psEnqEmail","psEnqPhone","psEnqMsg","psEnqErr","psEnqSend","psEnqBody","psEnqDone","psEnqDoneMsg","psEnqDoneClose",
     "psConfirm","psConfirmTitle","psConfirmMsg","psConfirmCancel","psConfirmGo",
     "psToast","psToastTx"].forEach(function(id){ el[id]=document.getElementById(id); });
  }

  /* ---------- start screen ---------- */
  function buildStart(){
    el.psRoomPick.innerHTML = Object.keys(ROOMS).map(function(k){
      var r=ROOMS[k];
      return '<button class="ps-rp" data-room="'+k+'"><span class="ic"><svg viewBox="0 0 24 24">'+r.icon+'</svg></span>'+
        '<h3>'+r.name+'</h3><p>'+r.desc+'</p>'+
        '<span class="go">Start this room <svg viewBox="0 0 24 24"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg></span></button>';
    }).join("");
    $$(".ps-rp", el.psRoomPick).forEach(function(b){ b.addEventListener("click",function(){ openFinishStep(b.dataset.room,"new"); }); });
    el.psSuiteChips.innerHTML = STARTS.map(function(n){
      return '<button class="ps-suite-chip" data-fin="'+esc(n)+'">'+SW(n)+'<span class="tx"><b>'+n+'</b><span>Coordinated room</span></span></button>';
    }).join("");
    $$(".ps-suite-chip", el.psSuiteChips).forEach(function(b){ b.addEventListener("click",function(){ newRoom("ensuite",null,b.dataset.fin); toast("Started a <b>"+b.dataset.fin+"</b> ensuite"); }); });
  }

  function showStart(){ el.psStart.classList.add("on"); el.psBoard.classList.remove("on"); renderProjUI(); }
  function showBoard(){ var fromStart=el.psStart.classList.contains("on"); el.psStart.classList.remove("on"); el.psBoard.classList.add("on"); wantSlotsEnter=true; render(); if(fromStart) window.scrollTo(0,0); }

  /* ---------- room lifecycle ---------- */
  function newRoom(typeKey, name, finish){
    var r=ROOMS[typeKey];
    project.rooms.push({ type:typeKey, name:name||r.name, items:[], finish:finish||null });
    project.active=project.rooms.length-1; save(); showBoard();
  }
  function itemsForSlot(room, slot){ return room.items.filter(function(it){return it.slot===slot;}); }
  /* the room's multi/accessory slot (bathroom-accessories vs sink-accessories etc.) */
  function roomAccessorySlot(room){ var slots=(ROOMS[room.type]||{}).slots||[]; for(var i=0;i<slots.length;i++){ if(SLOTS[slots[i]]&&SLOTS[slots[i]].multi) return slots[i]; } return null; }
  function addItem(slot, snap){
    var room=activeRoom(), def=SLOTS[slot];
    snap.slot=slot;
    if(def.multi){ room.items.push(snap); }
    else { var ex=itemsForSlot(room,slot); if(ex.length){ var i=room.items.indexOf(ex[0]); snap.qty=ex[0].qty||1; room.items[i]=snap; } else room.items.push(snap); }
    save(); render();
  }
  function removeItem(idx){ activeRoom().items.splice(idx,1); save(); render(); }
  function setItemQty(idx, delta){ var it=activeRoom().items[idx]; if(!it) return; var q=(it.qty||1)+delta; if(q<1) q=1; if(q>99) q=99; it.qty=q; save(); render(); }
  function duplicateRoom(idx){
    var src=project.rooms[idx]; if(!src) return;
    var copy={ type:src.type, name:src.name+" (copy)", finish:src.finish||null, budget:src.budget||null, brand:src.brand||null,
      items:src.items.map(function(it){ return JSON.parse(JSON.stringify(it)); }) };
    project.rooms.splice(idx+1,0,copy); project.active=idx+1; save(); render();
    toast("<b>"+esc(src.name)+"</b> duplicated");
  }
  function deleteRoom(idx){
    if(!project.rooms[idx]) return;
    project.rooms.splice(idx,1);
    if(!project.rooms.length){ project.active=0; save(); showStart(); return; }
    if(project.active>=project.rooms.length) project.active=project.rooms.length-1;
    save(); render();
  }
  function clearProject(){ project.rooms=[]; project.active=0; project.name="My project"; save(); showStart(); }

  /* reusable hard-confirm modal (floating, centered) for destructive actions */
  var confirmCb=null;
  function openConfirm(opts){
    if(!el.psConfirm) return;
    el.psConfirmTitle.textContent = opts.title || "Are you sure?";
    el.psConfirmMsg.textContent = opts.msg || "";
    el.psConfirmGo.textContent = opts.confirm || "Confirm";
    confirmCb = opts.onConfirm || null;
    el.psConfirm.classList.add("on"); syncScrollLock();
    setTimeout(function(){ try{ el.psConfirmCancel.focus(); }catch(e){} }, 60); // safe default focus
  }
  function closeConfirm(){ if(!el.psConfirm) return; el.psConfirm.classList.remove("on"); confirmCb=null; syncScrollLock(); }

  /* inline room rename — designed editor (no browser prompt) */
  function startRename(){
    var r=activeRoom(); if(!r) return;
    var ttl=el.psRoomName.parentNode;
    if(ttl.querySelector(".ps-rename")) return;
    var wrap=document.createElement("span"); wrap.className="ps-rename";
    var input=document.createElement("input");
    input.className="ps-rename-input"; input.type="text"; input.value=r.name; input.maxLength=40;
    input.setAttribute("aria-label","Room name"); input.placeholder="Room name";
    var acts=document.createElement("span"); acts.className="ps-rename-acts";
    var ok=document.createElement("button"); ok.type="button"; ok.className="ps-rename-ok"; ok.title="Save"; ok.setAttribute("aria-label","Save name");
    ok.innerHTML='<svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>';
    var cancel=document.createElement("button"); cancel.type="button"; cancel.className="ps-rename-cancel"; cancel.title="Cancel"; cancel.setAttribute("aria-label","Cancel");
    cancel.innerHTML='<svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5 5 19"/></svg>';
    acts.appendChild(ok); acts.appendChild(cancel);
    wrap.appendChild(input); wrap.appendChild(acts);
    el.psRoomName.style.display="none"; el.psRenameBtn.style.display="none";
    ttl.insertBefore(wrap, el.psRoomName);
    requestAnimationFrame(function(){ wrap.classList.add("in"); });
    input.focus(); input.select();
    var done=false;
    function commit(saveIt){
      if(done) return; done=true;
      if(saveIt){ var v=input.value.trim(); if(v) r.name=v; }
      if(wrap.parentNode) wrap.parentNode.removeChild(wrap);
      el.psRoomName.style.display=""; el.psRenameBtn.style.display="";
      save(); render();
    }
    input.addEventListener("keydown",function(e){ if(e.key==="Enter"){ e.preventDefault(); commit(true); } else if(e.key==="Escape"){ e.preventDefault(); commit(false); } });
    input.addEventListener("blur",function(){ setTimeout(function(){ if(done) return; if(wrap.contains(document.activeElement)) return; commit(true); },120); });
    ok.addEventListener("click",function(){ commit(true); });
    cancel.addEventListener("click",function(){ commit(false); });
  }

  /* ---------- room-finish step ---------- */
  function openFinishStep(typeKey, mode){
    var room=activeRoom();
    fstepCtx={ type:typeKey, sel:(mode==="change"&&room?room.finish:null), mode:mode||"new" };
    var rn=(mode==="change"&&room)?room.name:ROOMS[typeKey].name;
    el.psFstepEyebrow.textContent = mode==="change"?"Change room finish":"Step 2 · Your room finish";
    el.psFstepTitle.textContent = "What finish for your "+rn+"?";
    el.psFstepGrid.innerHTML = FAMILIES.map(function(n){
      return '<button class="ps-ftile'+(fstepCtx.sel===n?" on":"")+'" data-fin="'+esc(n)+'">'+SW(n)+'<b>'+n+'</b></button>';
    }).join("");
    $$(".ps-ftile", el.psFstepGrid).forEach(function(b){ b.addEventListener("click",function(){ pickFstep(b.dataset.fin); }); });
    el.psFstep.classList.add("on"); syncScrollLock();
  }
  function pickFstep(name){ fstepCtx.sel=name; $$(".ps-ftile", el.psFstepGrid).forEach(function(x){ x.classList.toggle("on", x.dataset.fin===name); }); }
  function confirmFstep(skip){
    var fin = skip?null:fstepCtx.sel;
    el.psFstep.classList.remove("on");
    syncScrollLock();
    if(fstepCtx.mode==="change"){ activeRoom().finish=fin; save(); render(); if(fin) toast("Room finish set to <b>"+fin+"</b>"); }
    else { newRoom(fstepCtx.type, null, fin); }
  }

  /* ---------- room brand lock (chooser modal, mirrors the finish step) ---------- */
  var brandCtx = { sel:null };
  function openBrandStep(){
    var room=activeRoom(); if(!room) return;
    brandCtx={ sel:room.brand||null };
    el.psBrandStepTitle.textContent = "Keep "+room.name+" to one brand";
    el.psBrandSearch.value="";
    buildBrandGrid("");
    el.psBrandStep.classList.add("on"); syncScrollLock();
    setTimeout(function(){ try{ el.psBrandSearch.focus(); }catch(e){} },140);
  }
  function buildBrandGrid(q){
    q=(q||"").toLowerCase().trim();
    var list=BRANDS.filter(function(b){ return b&&b.n && (!q || b.n.toLowerCase().indexOf(q)>=0); });
    list.sort(function(a,b){ return a.n.localeCompare(b.n); });
    if(!list.length){ el.psBrandGrid.innerHTML='<div class="ps-bstep-empty">No brands match that search.</div>'; return; }
    el.psBrandGrid.innerHTML=list.map(function(b){
      var on=brandCtx.sel===b.n;
      var lg=b.l?'<span class="lg"><img src="'+esc(b.l)+'" alt="'+esc(b.n)+'" loading="lazy" style="'+brandImgStyle(b.n)+'"></span>':'<span class="lg nologo">'+esc(b.n)+'</span>';
      return '<button class="ps-btile'+(on?" on":"")+'" data-brand="'+esc(b.n)+'">'+lg+'<b>'+esc(b.n)+'</b></button>';
    }).join("");
    $$(".ps-btile", el.psBrandGrid).forEach(function(x){ x.addEventListener("click",function(){ pickBrand(x.dataset.brand); }); });
  }
  function pickBrand(name){ brandCtx.sel=(brandCtx.sel===name)?null:name; $$(".ps-btile", el.psBrandGrid).forEach(function(x){ x.classList.toggle("on", x.dataset.brand===brandCtx.sel); }); }
  function closeBrandStep(){ el.psBrandStep.classList.remove("on"); syncScrollLock(); }
  function confirmBrand(clear){
    var b=clear?null:(brandCtx.sel||null);
    closeBrandStep();
    var room=activeRoom(); if(!room) return;
    room.brand=b; save(); render();
    if(b) toast("Room set to <b>"+esc(b)+"</b>"); else toast("Brand lock cleared");
  }
  function renderRoomBrand(room){
    if(!el.psRbrandBtn) return;
    if(room.brand){
      el.psRbrandBtn.classList.remove("unset");
      el.psRbrandLab.textContent=room.brand;
      var lg=BRAND_LOGO[room.brand];
      if(lg){ el.psRbrandLogo.style.display="inline-block"; el.psRbrandLogo.innerHTML='<img src="'+esc(lg)+'" alt="" style="object-fit:'+brandFit(room.brand)+'">'; }
      else { el.psRbrandLogo.style.display="none"; el.psRbrandLogo.innerHTML=""; }
    } else {
      el.psRbrandBtn.classList.add("unset");
      el.psRbrandLab.textContent="Any brand";
      el.psRbrandLogo.style.display="none"; el.psRbrandLogo.innerHTML="";
    }
  }

  /* ---------- finish schedule compute (target-aware) ---------- */
  /* Group the room's finish-bearing items by FINISH FAMILY (not raw product name),
     so messy per-product names consolidate into one entry per metal tone. */
  function computeFinish(room){
    var target=room.finish||null, targetFam=target?family(target):null;
    var finItems=room.items.filter(function(it){ return SLOTS[it.slot] && SLOTS[it.slot].fin && it.finish; });
    var byFam={};
    finItems.forEach(function(it){ var fam=it.family||family(it.finish)||finSlug(it.finish); if(!byFam[fam]) byFam[fam]={count:0,fam:fam,label:famLabel(fam)}; byFam[fam].count+=(it.qty||1); });
    var fams=Object.keys(byFam);
    var oddFams={}, nickelNear=false, nickelOddFam=null, offCount=0;
    function pair(a,b){ return (a==="warm-brushed-nickel"&&b==="brushed-nickel")||(a==="brushed-nickel"&&b==="warm-brushed-nickel"); }
    if(target){
      fams.forEach(function(f){ if(f===targetFam) return; oddFams[f]=true; if(pair(targetFam,f)){ nickelNear=true; nickelOddFam=f; } else offCount+=byFam[f].count; });
    } else {
      if(byFam["warm-brushed-nickel"]&&byFam["brushed-nickel"]){ nickelNear=true; nickelOddFam=(byFam["warm-brushed-nickel"].count<byFam["brushed-nickel"].count)?"warm-brushed-nickel":"brushed-nickel"; oddFams[nickelOddFam]=true; }
    }
    var coord = target?(finItems.length>0 && Object.keys(oddFams).length===0):(fams.length===1);
    var nudge=null;
    if(nickelNear) nudge={type:"nickel",fam:nickelOddFam};
    else if(target&&offCount>0) nudge={type:"off",count:offCount};
    return { target:target, targetFam:targetFam, byFam:byFam, fams:fams, oddFams:oddFams, coord:coord, nickelNear:nickelNear, nudge:nudge, total:finItems.length };
  }

  /* ---------- render ---------- */
  function render(){
    renderProjUI();
    renderTabs();
    var room=activeRoom(); if(!room) return;
    el.psRoomName.textContent=room.name;
    var def=ROOMS[room.type], fin=computeFinish(room);
    var html="";
    def.slots.forEach(function(slot){
      var sd=SLOTS[slot], items=itemsForSlot(room,slot);
      if(sd.multi){ items.forEach(function(it){ html+=slotCard(slot,it,room.items.indexOf(it),fin); }); html+=emptySlot(slot, items.length>0); }
      else if(items.length){ html+=slotCard(slot,items[0],room.items.indexOf(items[0]),fin); }
      else html+=emptySlot(slot,false);
    });
    el.psSlots.classList.toggle("ps-slots--enter", !!wantSlotsEnter); wantSlotsEnter=false;
    el.psSlots.innerHTML=html;
    wireSlots();
    var essSlots=def.slots.filter(function(s){return SLOTS[s].ess;});
    var essFilled=essSlots.filter(function(s){return itemsForSlot(room,s).length;}).length;
    el.psProgBar.style.width=(essSlots.length?Math.round(essFilled/essSlots.length*100):0)+"%";
    el.psProgTxt.textContent=essFilled+" of "+essSlots.length+" essentials";
    el.psItemCt.textContent=room.items.length;
    renderRoomFinish(room);
    renderRoomBrand(room);
    renderSchedule(fin);
    renderTotals(room);
    renderBudget(room);
    renderRecap();
    renderSuggest(room, fin);
    updateBadge();
    // room-management controls are meaningless while previewing a shared project
    [el.psRenameBtn, el.psDupBtn, el.psDelBtn].forEach(function(b){ if(b) b.style.display=sharedMode?"none":""; });
    if(el.psStartOver) el.psStartOver.style.display=(sharedMode||project.rooms.length<=1)?"none":"inline-flex";
  }

  function slotCard(slot, it, idx, fin){
    var sd=SLOTS[slot];
    var hasSale=it.compare&&it.compare>it.price;
    var coState="", coIcon="";
    if(sd.fin && it.finish){
      var ALERT='<path d="M12 9v4"/><path d="M12 17h.01"/><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/>';
      var CHECK='<path d="M20 6 9 17l-5-5"/>';
      var fam=it.family||family(it.finish)||finSlug(it.finish);
      if(fin.oddFams[fam]){ coState=" odd"; coIcon=ALERT; }
      else if(fin.target){ if(fam===fin.targetFam){ coState=" match"; coIcon=CHECK; } }
      else if(fin.total>1 && (fin.coord||fin.nickelNear)){ coState=" match"; coIcon=CHECK; }
    }
    var meta = it.vb
      ? ('<ul class="ps-scard-specs">'+vbSpecs(it).map(function(s){ return '<li>'+(s.k?'<b>'+esc(s.k)+':</b> ':'')+esc(s.v)+'</li>'; }).join("")+'</ul>')
      : (sd.fin && it.finish)
        ? '<span class="ps-scard-fin">'+SW(it.finish)+esc(finishDisplay(it.finish))+'</span>'
        : '<span class="ps-scard-mat"><svg viewBox="0 0 24 24"><path d="M4 7h16M4 12h16M4 17h16"/></svg>'+esc(sd.label)+'</span>';
    var qn=it.qty||1;
    // configured vanities are a fixed bundle — no qty stepper (keeps Cart Transform caps correct)
    var qty=it.vb ? '' : '<div class="ps-scard-qty">'+
      '<button class="ps-qstep" data-qm="'+idx+'" aria-label="Decrease quantity"'+(qn<=1?' disabled':'')+'><svg viewBox="0 0 24 24"><path d="M5 12h14"/></svg></button>'+
      '<span class="ps-qn">'+qn+'</span>'+
      '<button class="ps-qstep" data-qp="'+idx+'" aria-label="Increase quantity"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg></button>'+
      '</div>';
    return '<div class="ps-slot"><div class="ps-scard'+coState+'">'+
      '<span class="ps-scard-tag">'+esc(sd.label)+'</span>'+
      (coIcon?'<span class="ps-scard-cobadge"><svg viewBox="0 0 24 24">'+coIcon+'</svg></span>':'')+
      '<button class="ps-scard-rm" data-rm="'+idx+'" title="Remove"><svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5 5 19"/></svg></button>'+
      '<div class="ps-scard-im">'+(it.img?'<img src="'+esc(it.img)+'" alt="" onerror="this.style.opacity=.12">':'')+'</div>'+
      '<div class="ps-scard-bd">'+
        (it.brand?'<span class="ps-scard-vd">'+esc(it.brand)+'</span>':'')+
        '<span class="ps-scard-tt">'+esc(it.title)+'</span>'+
        (it.variant?'<span class="ps-scard-opt">'+esc(it.variant)+'</span>':'')+
        '<div class="ps-scard-meta">'+meta+qty+'</div>'+
        '<div class="ps-scard-bot">'+
          '<span class="ps-scard-pr">'+money(it.price)+(qn>1?'<small class="ea">'+money(it.price*qn)+' total</small>':(hasSale?'<small>'+money(it.compare)+'</small>':''))+'</span>'+
          '<button class="ps-scard-swap" data-swap="'+slot+'"><svg viewBox="0 0 24 24"><path d="M16 3l4 4-4 4"/><path d="M20 7H8a4 4 0 0 0-4 4M8 21l-4-4 4-4"/><path d="M4 17h12a4 4 0 0 0 4-4"/></svg>Swap</button>'+
        '</div>'+
        noteArea(it, idx)+
      '</div></div></div>';
  }
  /* per-item note - a quiet annotation ("tiler to confirm size", "check delivery") */
  function noteArea(it, idx){
    if(it.note){
      return '<div class="ps-scard-note has" data-noteidx="'+idx+'"><button class="ps-scard-noteline" data-note="'+idx+'" title="Edit note">'+
        '<svg viewBox="0 0 24 24"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg><span>'+esc(it.note)+'</span></button></div>';
    }
    return '<div class="ps-scard-note" data-noteidx="'+idx+'"><button class="ps-scard-noteadd" data-note="'+idx+'"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>Add a note</button></div>';
  }
  function openNoteEditor(idx){
    var room=activeRoom(); if(!room) return; var it=room.items[idx]; if(!it) return;
    var area=el.psSlots.querySelector('.ps-scard-note[data-noteidx="'+idx+'"]'); if(!area || area.querySelector(".ps-note-edit")) return;
    area.innerHTML="";
    var wrap=document.createElement("div"); wrap.className="ps-note-edit";
    var ta=document.createElement("textarea"); ta.className="ps-note-input"; ta.value=it.note||""; ta.rows=2; ta.maxLength=200;
    ta.placeholder="e.g. tiler to confirm size, check delivery date"; ta.setAttribute("aria-label","Note for "+(it.title||"this item"));
    var acts=document.createElement("div"); acts.className="ps-note-acts";
    var ok=document.createElement("button"); ok.type="button"; ok.className="ps-note-ok"; ok.textContent="Save note";
    var cancel=document.createElement("button"); cancel.type="button"; cancel.className="ps-note-cancel"; cancel.textContent="Cancel";
    acts.appendChild(ok); acts.appendChild(cancel);
    wrap.appendChild(ta); wrap.appendChild(acts); area.appendChild(wrap);
    ta.focus(); try{ ta.setSelectionRange(ta.value.length, ta.value.length); }catch(e){}
    var done=false;
    function commit(saveIt){ if(done) return; done=true; if(saveIt){ var v=ta.value.trim(); it.note = v||null; } save(); render(); }
    ok.addEventListener("click", function(){ commit(true); });
    cancel.addEventListener("click", function(){ commit(false); });
    // Enter = newline (multi-line notes); Ctrl/Cmd+Enter saves; Esc cancels; blur saves
    ta.addEventListener("keydown", function(e){ if(e.key==="Enter"&&(e.metaKey||e.ctrlKey)){ e.preventDefault(); commit(true); } else if(e.key==="Escape"){ e.preventDefault(); commit(false); } });
    ta.addEventListener("blur", function(){ setTimeout(function(){ if(done) return; if(wrap.contains(document.activeElement)) return; commit(true); },120); });
  }
  function emptySlot(slot, isMore){
    var sd=SLOTS[slot], cnt=COUNTS[sd.coll]||0;
    if(isMore){
      return '<div class="ps-slot ps-slot-more"><button class="ps-slot-empty opt" data-add="'+slot+'"><span class="sic"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg></span><span class="add">Add another accessory</span></button></div>';
    }
    return '<div class="ps-slot"><button class="ps-slot-empty'+(sd.ess?"":" opt")+'" data-add="'+slot+'">'+
      '<span class="sic"><svg viewBox="0 0 24 24">'+sd.ic+'</svg></span>'+
      '<span class="lab">'+esc(sd.label)+'</span>'+
      '<span class="add"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>Add '+esc(sd.label.toLowerCase())+'</span>'+
      (sd.hint
        ? '<span class="ps-opt-pill">Optional</span><span class="hint hint--note">'+esc(sd.hint)+'</span>'
        : '<span class="hint">'+((sd.ess?"":"Optional · ")+(cnt?cnt+" to choose from":"Browse"))+'</span>')+
      '</button></div>';
  }
  function wireSlots(){
    $$("#psSlots [data-add]").forEach(function(b){ b.addEventListener("click",function(){ openPicker(b.dataset.add); }); });
    $$("#psSlots [data-swap]").forEach(function(b){ b.addEventListener("click",function(e){ e.stopPropagation(); openPicker(b.dataset.swap); }); });
    $$("#psSlots [data-rm]").forEach(function(b){ b.addEventListener("click",function(e){ e.stopPropagation(); removeItem(+b.dataset.rm); }); });
    $$("#psSlots [data-qm]").forEach(function(b){ b.addEventListener("click",function(e){ e.stopPropagation(); setItemQty(+b.dataset.qm,-1); }); });
    $$("#psSlots [data-qp]").forEach(function(b){ b.addEventListener("click",function(e){ e.stopPropagation(); setItemQty(+b.dataset.qp,1); }); });
    $$("#psSlots [data-note]").forEach(function(b){ b.addEventListener("click",function(e){ e.stopPropagation(); openNoteEditor(+b.dataset.note); }); });
  }
  function renderTabs(){
    var html=project.rooms.map(function(r,i){
      return '<button class="ps-rtab'+(i===project.active?" on":"")+'" data-tab="'+i+'">'+(i===project.active?'<span class="dot"></span>':'')+esc(r.name)+'<span class="ct">'+r.items.length+'</span></button>';
    }).join("");
    html+='<button class="ps-rtab ps-rtab--add" id="psAddRoomTab"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>Add a room</button>';
    el.psRtabs.innerHTML=html;
    $$("#psRtabs [data-tab]").forEach(function(b){ b.addEventListener("click",function(){ if(+b.dataset.tab===project.active) return; project.active=+b.dataset.tab; wantSlotsEnter=true; save(); render(); }); });
    document.getElementById("psAddRoomTab").addEventListener("click", showStart);
  }
  /* ---------- project switcher UI ---------- */
  function renderProjUI(){
    if(!el.psProjName) return;
    el.psProjName.textContent = sharedMode ? "Shared project" : (activeProject() ? activeProject().name : "My project");
    if(el.psProjMenu && !el.psProjMenu.hidden) renderProjList();
    renderSaveTip();
  }
  /* one-time "keep it safe" nudge - shown once a project is a real investment, then never
     again once the user has saved/dismissed (we can't truly guarantee local storage). */
  var SAVETIP_AT = 5; // items in the active project before we gently suggest saving the link
  function noteSaved(){ if(workspace && !workspace.savetipDone){ workspace.savetipDone=true; persist(); } if(el.psSaveTip) el.psSaveTip.style.display="none"; }
  function renderSaveTip(){
    if(!el.psSaveTip) return;
    var items = (!sharedMode && project) ? project.rooms.reduce(function(a,r){return a+r.items.length;},0) : 0;
    var show = !sharedMode && workspace && !workspace.savetipDone && items >= SAVETIP_AT;
    el.psSaveTip.style.display = show ? "flex" : "none";
  }
  function renderProjList(){
    if(!el.psProjList) return;
    el.psProjList.innerHTML = workspace.projects.map(function(p,i){
      var items=p.rooms.reduce(function(a,r){return a+r.items.length;},0);
      return '<div class="ps-projrow'+(i===workspace.active?' on':'')+'">'+
        '<button class="ps-projrow-pick" data-pick="'+i+'"><b>'+esc(p.name)+'</b>'+
          '<span>'+p.rooms.length+' room'+(p.rooms.length===1?'':'s')+' &middot; '+items+' item'+(items===1?'':'s')+'</span></button>'+
        (workspace.projects.length>1?'<button class="ps-projrow-del" data-del="'+i+'" title="Delete project"><svg viewBox="0 0 24 24"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg></button>':'')+
      '</div>';
    }).join("");
    $$("[data-pick]", el.psProjList).forEach(function(b){ b.addEventListener("click",function(){ switchProject(+b.dataset.pick); }); });
    $$("[data-del]", el.psProjList).forEach(function(b){
      var armed=false, t;
      b.addEventListener("click",function(e){ e.stopPropagation();
        if(!armed){ armed=true; b.classList.add("arm"); b.title="Click again to delete"; clearTimeout(t); t=setTimeout(function(){ armed=false; b.classList.remove("arm"); b.title="Delete project"; },3000); return; }
        deleteProject(+b.dataset.del);
      });
    });
  }
  function openProjMenu(){ if(!el.psProjMenu) return; renderProjList(); el.psProjMenu.hidden=false; if(el.psProjMenuBtn) el.psProjMenuBtn.classList.add("on"); }
  function closeProjMenu(){ if(!el.psProjMenu) return; el.psProjMenu.hidden=true; if(el.psProjMenuBtn) el.psProjMenuBtn.classList.remove("on"); }
  function toggleProjMenu(){ if(!el.psProjMenu) return; if(el.psProjMenu.hidden) openProjMenu(); else closeProjMenu(); }
  /* inline project rename - SAME designed editor as the room rename (.ps-rename),
     just size-modified to fit the bar. No browser prompt. */
  function startProjectRename(){
    if(sharedMode || !el.psProjName) return;
    var host=el.psProjName.parentNode;
    if(host.querySelector(".ps-rename")) return;
    var cur=activeProject();
    var wrap=document.createElement("span"); wrap.className="ps-rename ps-rename--sm";
    var input=document.createElement("input");
    input.className="ps-rename-input"; input.type="text"; input.value=cur.name; input.maxLength=48;
    input.setAttribute("aria-label","Project name"); input.placeholder="Project name";
    var acts=document.createElement("span"); acts.className="ps-rename-acts";
    var ok=document.createElement("button"); ok.type="button"; ok.className="ps-rename-ok"; ok.title="Save"; ok.setAttribute("aria-label","Save name");
    ok.innerHTML='<svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>';
    var cancel=document.createElement("button"); cancel.type="button"; cancel.className="ps-rename-cancel"; cancel.title="Cancel"; cancel.setAttribute("aria-label","Cancel");
    cancel.innerHTML='<svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5 5 19"/></svg>';
    acts.appendChild(ok); acts.appendChild(cancel);
    wrap.appendChild(input); wrap.appendChild(acts);
    el.psProjName.style.display="none"; if(el.psProjRename) el.psProjRename.style.display="none";
    host.insertBefore(wrap, el.psProjName);
    requestAnimationFrame(function(){ wrap.classList.add("in"); });
    input.focus(); input.select();
    var done=false;
    function commit(saveIt){
      if(done) return; done=true;
      if(saveIt){ var v=input.value.trim(); if(v) cur.name=v; }
      if(wrap.parentNode) wrap.parentNode.removeChild(wrap);
      el.psProjName.style.display=""; if(el.psProjRename) el.psProjRename.style.display="";
      save();
    }
    input.addEventListener("keydown",function(e){ if(e.key==="Enter"){ e.preventDefault(); commit(true); } else if(e.key==="Escape"){ e.preventDefault(); commit(false); } });
    input.addEventListener("blur",function(){ setTimeout(function(){ if(done) return; if(wrap.contains(document.activeElement)) return; commit(true); },120); });
    ok.addEventListener("click",function(){ commit(true); });
    cancel.addEventListener("click",function(){ commit(false); });
  }
  function renderRoomFinish(room){
    if(room.finish){ el.psRfinBtn.classList.remove("unset"); el.psRfinSw.style.display="inline-block"; el.psRfinSw.className="sw sw-metal sw--"+finSlug(room.finish); el.psRfinLab.textContent=room.finish; }
    else { el.psRfinBtn.classList.add("unset"); el.psRfinSw.style.display="none"; el.psRfinLab.textContent="Set room finish"; }
  }
  function renderSchedule(fin){
    var t=el.psFschedTitle;
    if(!fin.total){
      t.classList.toggle("coord", !!fin.target);
      t.firstChild.textContent = fin.target?("Building in "+fin.target+" "):"Your finishes ";
      el.psFschedChips.innerHTML=""; el.psFschedEmpty.style.display="block";
      el.psFschedEmpty.textContent = fin.target?("Room finish set to "+fin.target+". As you add tapware, a shower or accessories we'll keep them on this tone."):"Add tapware, a shower or accessories and your metal finishes will appear here — we'll keep them coordinated.";
      el.psFschedNudge.classList.remove("on"); return;
    }
    el.psFschedEmpty.style.display="none";
    t.classList.toggle("coord", fin.coord);
    t.firstChild.textContent = fin.coord?"Fully coordinated ":"Your finishes ";
    el.psFschedChips.innerHTML = fin.fams.map(function(f){
      var rec=fin.byFam[f], odd=!!fin.oddFams[f], c=rec.count;
      return '<div class="ps-fchip'+(odd?" ps-fchip--odd":"")+'">'+swSlug(f)+'<span class="tx"><b>'+esc(rec.label)+'</b><span>'+c+' piece'+(c>1?"s":"")+(odd&&fin.target?" · off-finish":"")+'</span></span></div>';
    }).join("");
    if(fin.nudge){
      el.psFschedNudge.classList.add("on");
      var msg;
      if(fin.nudge.type==="nickel") msg='<b>Two nickel tones are very close.</b> '+(fin.target?("Your room is "+fin.target+", but one piece is the other nickel"):"Most pieces are one nickel; one is the other")+' — worth a glance the mix is intentional.';
      else msg='<b>'+fin.nudge.count+' piece'+(fin.nudge.count>1?"s aren't":" isn't")+' in your '+fin.target+' finish.</b> Fine if that\'s deliberate — otherwise swap to keep the room coordinated.';
      el.psNudgeTx.innerHTML = msg+'<br><button class="review" id="psNudgeReview">Review it</button>';
      document.getElementById("psNudgeReview").addEventListener("click",function(){
        var card=$$("#psSlots .ps-scard.odd")[0];
        if(card){ card.scrollIntoView({behavior:"smooth",block:"center"}); card.classList.remove("pulse"); void card.offsetWidth; card.classList.add("pulse"); }
      });
    } else el.psFschedNudge.classList.remove("on");
  }
  function renderTotals(room){
    var sub=0,save2=0;
    room.items.forEach(function(it){ var q=it.qty||1; sub+=(it.price||0)*q; if(it.compare&&it.compare>it.price) save2+=(it.compare-it.price)*q; });
    el.psSubVal.textContent=money(sub);
    el.psSubLabel.textContent="Subtotal ("+room.items.length+" item"+(room.items.length===1?"":"s")+")";
    el.psTotalVal.textContent=money(sub);
    if(save2>0){ el.psSaveRow.style.display="flex"; el.psSaveVal.textContent="-"+money(save2); } else el.psSaveRow.style.display="none";
    /* mirror the total onto the mobile sticky action bar (always shown on the board) */
    if(el.psBarTotal) el.psBarTotal.textContent=money(sub);
  }
  function renderRecap(){
    if(project.rooms.length<=1){ el.psRecap.style.display="none"; return; }
    el.psRecap.style.display="block";
    var grand=0, budgetSum=0, anyBudget=false;
    el.psRecapRows.innerHTML=project.rooms.map(function(r,i){
      var sub=0; r.items.forEach(function(it){ sub+=(it.price||0)*(it.qty||1); }); grand+=sub;
      var note="";
      if(r.budget){ anyBudget=true; budgetSum+=r.budget; var over=sub>r.budget;
        note='<span class="bg '+(over?"over":"under")+'">'+(over?money(sub-r.budget)+" over":money(r.budget-sub)+" left")+'</span>'; }
      return '<div class="ps-recap-row"><span class="nm"><span class="d" style="opacity:'+(i===project.active?1:.3)+'"></span><b>'+esc(r.name)+'</b><span class="ct">'+r.items.length+' items</span></span><span class="vv">'+money(sub)+note+'</span></div>';
    }).join("");
    el.psRecapTot.textContent=money(grand);
    if(el.psRecapBudget){
      if(anyBudget){ var over=grand>budgetSum;
        el.psRecapBudget.style.display="flex"; el.psRecapBudget.className="ps-recap-budget"+(over?" over":"");
        el.psRecapBudgetVal.textContent = over ? money(grand-budgetSum)+" over" : money(budgetSum-grand)+" under";
      } else el.psRecapBudget.style.display="none";
    }
  }
  /* ---------- budget tracker (per-room, optional; rides in localStorage via save()) ---------- */
  function roomSpent(room){ var s=0; room.items.forEach(function(it){ s+=(it.price||0)*(it.qty||1); }); return s; }
  function renderBudget(room){
    if(!el.psBudget) return;
    var b=room.budget||0, spent=roomSpent(room);
    el.psBudgetAdd.style.display = (!b && !sharedMode) ? "inline-flex" : "none";
    if(!b){ el.psBudgetOn.style.display="none"; el.psBudget.classList.remove("over"); return; }
    el.psBudgetOn.style.display="block";
    var over=spent>b, pct = b>0 ? Math.min(100, Math.round(spent/b*100)) : 0;
    el.psBudgetFill.style.width=pct+"%";
    el.psBudget.classList.toggle("over", over);
    el.psBudgetStatus.innerHTML = over
      ? money(spent)+" spent &middot; <b>"+money(spent-b)+" over budget</b>"
      : money(spent)+" of "+money(b)+" &middot; <b>"+money(b-spent)+" to spend</b>";
    el.psBudgetEdit.style.display = sharedMode ? "none" : "inline";
  }
  function openBudgetEditor(){
    var r=activeRoom(); if(!r||sharedMode) return;
    if(el.psBudget.querySelector(".ps-budget-edit-wrap")) return;
    el.psBudgetAdd.style.display="none"; el.psBudgetOn.style.display="none";
    var wrap=document.createElement("div"); wrap.className="ps-budget-edit-wrap";
    var field=document.createElement("div"); field.className="ps-budget-field";
    var cur=document.createElement("span"); cur.className="cur"; cur.textContent="$";
    var input=document.createElement("input");
    input.className="ps-budget-input"; input.type="text"; input.inputMode="numeric"; input.autocomplete="off";
    input.value = r.budget ? Math.round(r.budget/100).toLocaleString("en-AU") : "";
    input.placeholder="5,000"; input.setAttribute("aria-label","Room budget in dollars");
    field.appendChild(cur); field.appendChild(input);
    var acts=document.createElement("span"); acts.className="ps-budget-acts";
    var ok=document.createElement("button"); ok.type="button"; ok.className="ps-budget-ok"; ok.title="Save"; ok.setAttribute("aria-label","Save budget");
    ok.innerHTML='<svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>';
    var cancel=document.createElement("button"); cancel.type="button"; cancel.className="ps-budget-cancel"; cancel.title="Cancel"; cancel.setAttribute("aria-label","Cancel");
    cancel.innerHTML='<svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5 5 19"/></svg>';
    acts.appendChild(ok); acts.appendChild(cancel);
    wrap.appendChild(field); wrap.appendChild(acts);
    el.psBudget.appendChild(wrap);
    requestAnimationFrame(function(){ wrap.classList.add("in"); });
    input.focus(); var L=input.value.length; try{ input.setSelectionRange(L,L); }catch(e){}
    var done=false;
    function cleanup(){ if(wrap.parentNode) wrap.parentNode.removeChild(wrap); }
    function commit(saveIt){
      if(done) return; done=true;
      if(saveIt){ var n=parseInt(input.value.replace(/[^0-9]/g,""),10); r.budget = (n&&n>0) ? n*100 : null; }
      cleanup(); save(); render();
    }
    // live thousands-grouping as they type
    input.addEventListener("input",function(){ var n=input.value.replace(/[^0-9]/g,""); input.value = n ? parseInt(n,10).toLocaleString("en-AU") : ""; });
    input.addEventListener("keydown",function(e){ if(e.key==="Enter"){ e.preventDefault(); commit(true); } else if(e.key==="Escape"){ e.preventDefault(); commit(false); } });
    input.addEventListener("blur",function(){ setTimeout(function(){ if(done) return; if(wrap.contains(document.activeElement)) return; commit(true); },120); });
    ok.addEventListener("click",function(){ commit(true); });
    cancel.addEventListener("click",function(){ commit(false); });
    if(r.budget){
      var clr=document.createElement("button"); clr.type="button"; clr.className="ps-budget-clear"; clr.textContent="Remove budget";
      wrap.appendChild(clr);
      clr.addEventListener("click",function(){ if(done) return; done=true; r.budget=null; cleanup(); save(); render(); });
    }
  }

  /* ---------- matching suggestions (in-room rail) ---------- */
  function renderSuggest(room, fin){
    var dom = room.finish || (fin.fams.length? famLabel(fin.fams.slice().sort(function(a,b){return fin.byFam[b].count-fin.byFam[a].count;})[0]) : null);
    if(!dom){ el.psSuggest.style.display="none"; return; }
    var fam=family(dom);
    var accSlot=roomAccessorySlot(room), accColl=accSlot?SLOTS[accSlot].coll:"bathroom-accessories";
    var have={}; room.items.forEach(function(it){ have[it.handle]=true; });
    fetchSuggest(accColl).then(function(nodes){
      if(!nodes) { el.psSuggest.style.display="none"; return; }
      var picks=nodes.filter(function(n){ return n.dataset.family===fam && !have[n.dataset.handle]; }).slice(0,6);
      if(picks.length<2){ el.psSuggest.style.display="none"; return; }
      el.psSuggest.style.display="block";
      el.psSuggestTitle.textContent="Finish your "+dom.replace("Warm ","")+" suite";
      el.psSuggestSub.textContent="Matching pieces in "+dom+" — coordinate the whole room in one tone.";
      el.psSuggestAll.href = ROOT+"collections/"+accColl;
      el.psSuggestRail.innerHTML="";
      picks.forEach(function(n){ var c=n.cloneNode(true); c.style.display=""; addMatchBadge(c); el.psSuggestRail.appendChild(c); });
    });
  }
  function fetchSuggest(coll){
    if(sugCache[coll]) return Promise.resolve(sugCache[coll]);
    return fetchPage(coll,1).then(function(res){ sugCache[coll]=res?res.nodes:null; return sugCache[coll]; });
  }

  /* ---------- picker (Section Rendering API) ---------- */
  /* result layout: grid (default) or list; persisted, surfaced on mobile only.
     A class on the grid container reflows the SAME .pc-pick cards via CSS, so
     there's no second render. Mirrors the header search palette toggle. */
  var pkView = (function(){ try{ return localStorage.getItem("psPkView")==="list"?"list":"grid"; }catch(e){ return "grid"; } })();
  function applyPkView(){
    if(el.psPkGrid) el.psPkGrid.classList.toggle("is-list", pkView==="list");
    if(el.psPkView) $$(".ps-pk-view-b", el.psPkView).forEach(function(b){ b.classList.toggle("on", b.dataset.pkview===pkView); });
  }
  function setPkView(v){ pkView=(v==="list")?"list":"grid"; try{ localStorage.setItem("psPkView",pkView); }catch(e){} applyPkView(); }
  function openPicker(slot){
    picker.slot=slot; picker.coordOn=true; picker.nodes=[]; picker.nextPage=null;
    var sd=SLOTS[slot]; picker.coll=sd.coll; picker.sub=null; picker.kw=null;
    picker.brand=(activeRoom()&&activeRoom().brand)||null;   // inherit the room's brand lock (overridable per fixture)
    el.psPkBrands.classList.add("hide"); el.psPkBrandsStrip.innerHTML="";
    el.psPkEyebrow.textContent = sd.ess?"Essential fixture":"Add to your room";
    el.psPkTitle.textContent = "Choose your "+sd.label.toLowerCase();
    el.psPkSearch.value="";
    var room=activeRoom(), fin=computeFinish(room);
    var dom = room.finish || (fin.fams.length? famLabel(fin.fams.slice().sort(function(a,b){return fin.byFam[b].count-fin.byFam[a].count;})[0]) : null);
    if(sd.fin && dom){ el.psPkCoord.classList.remove("hide"); setCoordBanner(dom,true); picker.dom=dom; }
    else { el.psPkCoord.classList.add("hide"); picker.dom=null; }
    renderSubChips();
    el.psScrim.classList.add("on"); el.psPicker.classList.add("on"); syncScrollLock();
    applyPkView();
    loadPicker(true);
  }
  function setCoordBanner(dom,on){
    if(on){ el.psPkCoord.classList.remove("allfin"); el.psPkCoordSw.className="sw sw-metal sw--"+finSlug(dom); el.psPkCoordTx.innerHTML='Showing pieces that match your <b>'+esc(dom)+'</b>'; el.psPkCoordTog.textContent="Show all finishes"; }
    else { el.psPkCoord.classList.add("allfin"); el.psPkCoordSw.className="sw"; el.psPkCoordTx.innerHTML='Showing <b>all finishes</b> in this category'; el.psPkCoordTog.textContent="Match my finish"; }
  }
  function renderSubChips(){
    var sd=SLOTS[picker.slot], subs=sd.subs||[], base=sd.coll;
    if(!subs.length){ el.psPkSubs.classList.add("hide"); el.psPkSubs.innerHTML=""; return; }
    el.psPkSubs.classList.remove("hide");
    function chip(label, coll, kw, cnt){
      var on=(picker.coll===coll && (picker.kw||"")===(kw||""));
      return '<button class="ps-pksub'+(on?" on":"")+'" data-coll="'+coll+'" data-kw="'+(kw||"")+'">'+esc(label)+(cnt?'<span>'+cnt+'</span>':'')+'</button>';
    }
    var chips=chip(sd.subAllLabel||"All", base, "", COUNTS[base]);
    chips+=subs.map(function(s){
      return s.kw ? chip(s.n, base, s.kw, 0)          // keyword filter within the base collection
                  : chip(s.n, s.coll, "", COUNTS[s.coll]); // switch to a different collection
    }).join("");
    el.psPkSubs.innerHTML=chips;
    $$(".ps-pksub", el.psPkSubs).forEach(function(b){ b.addEventListener("click",function(){
      var coll=b.dataset.coll, kw=b.dataset.kw||null;
      if(picker.coll===coll && (picker.kw||"")===(kw||"")) return;
      var collChanged=(picker.coll!==coll);
      picker.coll=coll; picker.kw=kw;
      renderSubChips();
      if(collChanged) loadPicker(true);   // new collection -> refetch
      else applyPickerFilter();           // same collection, re-filter by keyword only
    }); });
  }
  /* brand filter strip — built from the brands actually present in the loaded category
     (logos = same metaobject image used elsewhere). Single-select; combines (AND) with
     finish/sub-type/search. A locked/selected brand is always shown so it can be cleared. */
  function renderBrandStrip(){
    if(!el.psPkBrands) return;
    var map={}, order=[];
    picker.nodes.forEach(function(n){
      var bn=n.dataset.brand; if(!bn) return;
      if(!map[bn]){ map[bn]={name:bn, logo:n.dataset.brandLogo||BRAND_LOGO[bn]||""}; order.push(bn); }
    });
    if(picker.brand && !map[picker.brand]){ map[picker.brand]={name:picker.brand, logo:BRAND_LOGO[picker.brand]||""}; order.push(picker.brand); }
    if(order.length<2 && !picker.brand){ el.psPkBrands.classList.add("hide"); el.psPkBrandsStrip.innerHTML=""; return; }
    order.sort(function(a,b){ return a.localeCompare(b); });
    el.psPkBrands.classList.remove("hide");
    var html='<button class="ps-pkbrand ps-pkbrand-all'+(picker.brand?"":" on")+'" data-brand="">All</button>';
    html+=order.map(function(bn){
      var b=map[bn], on=picker.brand===bn;
      var inner=b.logo?'<img src="'+esc(b.logo)+'" alt="'+esc(bn)+'" loading="lazy" style="'+brandImgStyle(bn)+'">':'<span class="ps-pkbrand-tx">'+esc(bn)+'</span>';
      return '<button class="ps-pkbrand'+(on?" on":"")+(b.logo?"":" nologo")+'" data-brand="'+esc(bn)+'" title="'+esc(bn)+'">'+inner+'</button>';
    }).join("");
    el.psPkBrandsStrip.innerHTML=html;
    $$(".ps-pkbrand", el.psPkBrandsStrip).forEach(function(btn){ btn.addEventListener("click",function(){
      var bn=btn.dataset.brand||null;
      picker.brand=(picker.brand===bn)?null:bn;   // toggle off on re-click; "All" (empty) clears
      renderBrandStrip(); applyPickerFilter();
    }); });
  }
  function fetchPage(coll, page){
    var url = ROOT+"collections/"+coll+"?section_id=atelier-project-picker"+(page>1?("&page="+page):"");
    return fetch(url, {headers:{"Accept":"text/html"}}).then(function(r){ return r.ok?r.text():null; }).then(function(html){
      if(!html) return null;
      var doc=new DOMParser().parseFromString(html,"text/html");
      var root=doc.getElementById("psPickerResults");
      var np=root?root.getAttribute("data-next-page"):""; np=np?parseInt(np,10):null;
      var nodes=root?$$(".pc-pick",root).map(function(e){ return document.importNode(e,true); }):[];
      return { nodes:nodes, nextPage:np };
    }).catch(function(e){ console.error("[project-studio] fetch",e); return null; });
  }
  function loadPicker(reset){
    if(reset){ picker.gen=(picker.gen||0)+1; picker.curPage=0; picker.nextPage=null; picker.nodes=[]; }
    else if(picker.loading) return;
    var myGen=picker.gen;
    picker.loading=true;
    if(reset){ renderLoader(el.psPkGrid); el.psPkCount.textContent=""; }
    var page = reset?1:(picker.curPage?picker.curPage+1:2);
    fetchPage(picker.coll, page).then(function(res){
      if(myGen!==picker.gen) return;   // superseded by a newer open / sub-type switch
      picker.loading=false;
      if(reset) el.psPkGrid.innerHTML="";
      if(!res){ el.psPkGrid.innerHTML='<div class="ps-pk-empty">Couldn’t load this category. Please try again.</div>'; return; }
      picker.curPage=page; picker.nextPage=res.nextPage;
      res.nodes.forEach(function(n){ picker.nodes.push(n); el.psPkGrid.appendChild(n); if(picker.dom && (n.dataset.families||n.dataset.family||"").split(" ").indexOf(family(picker.dom))>=0) addMatchBadge(n); n.style.display="none"; });
      renderBrandStrip();
      applyPickerFilter();
    });
  }
  /* while a finish/search filter is active, keep pulling pages so the filtered
     set is COMPLETE without the user clicking "Load more" (capped for safety). */
  function maybeAutoLoad(filtering){
    if(!filtering || !picker.nextPage || picker.loading) return;
    if((picker.curPage||1) >= 12) return; // ~576 products — every category is smaller
    loadPicker(false);
  }
  function addMatchBadge(n){
    var im=n.querySelector(".pc-im"); if(!im || n.querySelector(".is-matchb")) return;
    var bz=n.querySelector(".pc-badges"); if(!bz){ bz=document.createElement("div"); bz.className="pc-badges"; im.insertBefore(bz, im.firstChild); }
    var b=document.createElement("span"); b.className="pbadge is-matchb"; b.style.cssText="background:#1c7a4a;color:#fff";
    b.innerHTML='<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Matches'; bz.insertBefore(b, bz.firstChild);
  }
  function applyPickerFilter(){
    var sd=SLOTS[picker.slot];
    var q=(el.psPkSearch.value||"").toLowerCase().trim();
    var domFam=(sd.fin && picker.dom && picker.coordOn)?family(picker.dom):null;
    var kw=picker.kw||"";
    var kwNeg=kw.charAt(0)==="!", kwNeedle=kwNeg?kw.slice(1):kw;
    var brand=picker.brand||"";
    var filtering = !!domFam || !!q || !!kw || !!brand;
    var shown=0;
    picker.nodes.forEach(function(n){
      var okFin = !domFam || (n.dataset.families||n.dataset.family||"").split(" ").indexOf(domFam)>=0;
      var okQ = !q || (n.dataset.search||"").indexOf(q)>=0;
      var okBrand = !brand || n.dataset.brand===brand;
      var okKw = true;
      if(kw){ var hit=(n.dataset.search||"").indexOf(kwNeedle)>=0; okKw=kwNeg?!hit:hit; }
      var vis=okFin&&okQ&&okKw&&okBrand; n.style.display=vis?"":"none"; if(vis) shown++;
    });
    var suffix = domFam ? " in your finish" : " in this category";
    var tail="";
    if(filtering && picker.nextPage) tail=' &middot; <span class="ps-pk-loadingtxt">finding more&hellip;</span>';
    else if(picker.nextPage) tail=' &middot; <button class="ps-pk-moreinline" id="psPkMore">Load more</button>';
    el.psPkCount.innerHTML = '<b>'+shown+'</b> '+(shown===1?"option":"options")+suffix+tail;
    var mb=document.getElementById("psPkMore"); if(mb) mb.addEventListener("click",function(){ loadPicker(false); });
    // only declare "no matches" once filtering has nothing left to load
    if(shown===0 && !picker.loading && !(filtering && picker.nextPage)){
      if(!el.psPkGrid.querySelector(".ps-pk-empty")){ var d=document.createElement("div"); d.className="ps-pk-empty";
        d.textContent = domFam ? "No matches in your finish here. Tap “Show all finishes”, or try a sub-type or the search."
          : brand ? ("No "+brand+" pieces in this category. Tap “All” in the brand row, or try a sub-type.")
          : "No matches. Clear the search or try a sub-type."; el.psPkGrid.appendChild(d); }
    } else { var e0=el.psPkGrid.querySelector(".ps-pk-empty"); if(e0) e0.remove(); }
    maybeAutoLoad(filtering);
  }
  function closePicker(){ el.psScrim.classList.remove("on"); el.psPicker.classList.remove("on"); syncScrollLock(); }

  /* ============================================================
     VARIANT (OPTIONS) CHOOSER - for multi-variant products (size,
     hand, with/without basin, etc.). The picker emits a "View options"
     button + a JSON list of the product's variants; we surface them
     here and add the chosen variant (its id/price/label) to the room.
     ============================================================ */
  var vstepCtx={ node:null, snap:null, variants:[], sel:null, slot:null, fromSuggest:false };
  function parseVariants(node){
    var s=node?node.querySelector("script.pc-variants"):null; if(!s) return [];
    try{ return JSON.parse(s.textContent)||[]; }catch(e){ return []; }
  }
  function openVariantStep(node, slot, fromSuggest){
    if(!node || !slot || !el.psVariantStep) return;
    var d=node.dataset;
    vstepCtx.node=node; vstepCtx.slot=slot; vstepCtx.fromSuggest=!!fromSuggest;
    vstepCtx.snap={ handle:d.handle, title:d.title, brand:d.brand, img:d.img, finish:d.finish||"", family:d.family||"", url:d.url };
    vstepCtx.variants=parseVariants(node);
    var firstAvail=null; vstepCtx.variants.forEach(function(v){ if(firstAvail===null && v.a) firstAvail=v.id; });
    vstepCtx.sel=firstAvail;
    el.psVstepTitle.textContent=d.title||"Choose an option";
    el.psVstepProd.innerHTML=(d.img?'<img src="'+esc(d.img)+'" alt="">':'')+'<div>'+(d.brand?'<span class="ps-vstep-vd">'+esc(d.brand)+'</span>':'')+'<b>'+esc(d.title||"")+'</b></div>';
    renderVstepList();
    el.psVariantStep.classList.add("on"); syncScrollLock();
  }
  function renderVstepList(){
    el.psVstepList.innerHTML=vstepCtx.variants.map(function(v){
      var on=v.id===vstepCtx.sel, sale=v.c&&v.c>v.p;
      return '<button type="button" class="ps-vrow'+(on?" on":"")+(v.a?"":" soldout")+'"'+(v.a?'':' disabled')+' data-vid="'+v.id+'">'+
        '<span class="ps-vrow-t">'+esc(v.t)+(v.a?'':' <small>Sold out</small>')+'</span>'+
        '<span class="ps-vrow-p">'+money(v.p)+(sale?'<small>'+money(v.c)+'</small>':'')+'</span>'+
        '</button>';
    }).join("");
    $$(".ps-vrow", el.psVstepList).forEach(function(b){ if(b.disabled) return; b.addEventListener("click",function(){ vstepCtx.sel=parseInt(b.dataset.vid,10); renderVstepList(); }); });
    el.psVstepGo.disabled = vstepCtx.sel==null;
  }
  function closeVariantStep(){ if(!el.psVariantStep) return; el.psVariantStep.classList.remove("on"); vstepCtx.node=null; syncScrollLock(); }
  function confirmVariantStep(){
    var v=null; vstepCtx.variants.forEach(function(x){ if(x.id===vstepCtx.sel) v=x; });
    if(!v || !v.a || !vstepCtx.slot) return;
    var base=vstepCtx.snap;
    var snap={ handle:base.handle, title:base.title, brand:base.brand, price:v.p, compare:(v.c&&v.c>v.p)?v.c:0,
      img:v.img||base.img, finish:base.finish, family:base.family, vid:v.id, url:base.url,
      variant:(v.t&&v.t!=="Default Title")?v.t:"" };
    addItem(vstepCtx.slot, snap);
    closeVariantStep();
    if(!vstepCtx.fromSuggest && el.psPicker.classList.contains("on")) closePicker();
    toast((snap.brand?snap.brand+" ":"")+(snap.title||"Item").split(",")[0]+(snap.variant?" ("+snap.variant+")":"")+" added");
  }

  /* ============================================================
     VANITY BUILDER (configurable ADP vanities) — runs the REAL builder
     inline, in the planner, with zero changes to the builder itself.
     We fetch the builder snippet via Section Rendering, inject it, then
     re-activate its <script> tags (innerHTML scripts don't auto-run) in
     document order — so the core builder JS + Glacier JS (+ anything the
     team adds later) all load automatically. The builder's own add-to-cart
     opens the Atelier drawer (see the cart-drawer fallback in
     assets/vanity-builder.js). The configured vanity is a multi-line cart
     bundle (vanity + basin + handle + plug&waste, repriced by Cart
     Transform), so it goes straight to cart rather than into the room model.
     ============================================================ */
  /* Re-run the executable <script> tags inside an injected fragment, in
     document order (sequencing external loads). JSON data scripts
     (e.g. #vb-config-json, #vb-glacier-config) are left intact. */
  function activateScripts(host){
    var all=$$("script", host);
    var execs=all.filter(function(s){ if(s.src) return true; var t=(s.getAttribute("type")||"").toLowerCase(); return t===""||t==="text/javascript"||t==="module"; });
    (function run(i){
      if(i>=execs.length) return;
      var old=execs[i], s=document.createElement("script");
      for(var a=0;a<old.attributes.length;a++) s.setAttribute(old.attributes[a].name, old.attributes[a].value);
      if(old.src){ s.removeAttribute("defer"); s.removeAttribute("async"); s.onload=function(){ run(i+1); }; s.onerror=function(){ run(i+1); }; old.parentNode.replaceChild(s, old); }
      else { s.textContent=old.textContent; old.parentNode.replaceChild(s, old); run(i+1); }
    })(0);
  }
  function parsePriceCents(txt){ if(!txt) return 0; var f=parseFloat(txt.replace(/[^0-9.]/g,"")); return isFinite(f)?Math.round(f*100):0; }
  /* the builder hands us its assembled bundle (vanity + basin + handle + P&W,
     all with properties) — store it as the vanity slot item; it's added to the
     cart, intact, when the room is. */
  function onVbConfigured(items, handle, node){
    if(!items || !items.length){ toast("Finish your build first"); return; }
    var st=(window.VBShared && window.VBShared.state) || {};
    var vp=(items[0] && items[0].properties) || {};   // the vanity line's properties (what the cart shows)
    var byKey={};
    if(st.size) byKey["Size"]=st.size+"mm";
    Object.keys(vp).forEach(function(k){ if(k.charAt(0)!=="_" && k!=="Added with" && vp[k]) byKey[k]=String(vp[k]); });
    if(st.basinName && st.basinName!=="No Basin") byKey["Basin"]=st.basinName;
    var specs=[];
    VB_SPEC_ORDER.forEach(function(k){ if(byKey[k]){ specs.push({ k:k, v:byKey[k] }); delete byKey[k]; } });
    Object.keys(byKey).forEach(function(k){ specs.push({ k:k, v:byKey[k] }); }); // any extras not in the order list
    var pe=document.getElementById("vb-price")||document.getElementById("vb-price-m");
    var snap={ slot:"vanity", vb:true, qty:1,
      handle:handle,
      title:(node&&node.dataset.title)||(st.size?("ADP vanity"):"Configured vanity"),
      brand:(node&&node.dataset.brand)||"",
      img:(node&&node.dataset.img)||"",
      price:parsePriceCents(pe?pe.textContent:""), compare:0,
      finish:"", family:"",
      specs:specs,
      config:(specs.map(function(s){return s.k+": "+s.v;}).join(" · ")) || "Configured to order",
      bundle:items.map(function(b){ return { id:b.id, quantity:b.quantity||1, properties:b.properties||null }; }) };
    addItem("vanity", snap);
    closeVbView();
    toast("<b>"+esc(snap.title)+"</b> added to your project");
  }
  function openVbView(handle, node){
    if(!handle) return;
    vbView=true;
    if(el.psPicker.classList.contains("on")) closePicker();
    el.psStart.classList.remove("on"); el.psBoard.classList.remove("on");
    el.psVbView.classList.add("on");
    el.psVbTitle.textContent=(node&&node.dataset.title)?node.dataset.title:"Build your vanity";
    window.scrollTo(0,0);
    renderLoader(el.psVbHost, "Loading the vanity builder…");
    // the builder routes its add-to-cart to us instead of the cart (see submitCart guard)
    window.VB_PROJECT_ADD=function(items){ onVbConfigured(items, handle, node); };
    fetch(ROOT+"products/"+encodeURIComponent(handle)+"?section_id=atelier-project-vb",{headers:{Accept:"text/html"}})
      .then(function(r){ return r.ok?r.text():null; })
      .then(function(html){
        if(!vbView) return; // user backed out while loading
        if(!html || html.indexOf("data-vb-na")>=0){ el.psVbHost.innerHTML='<p class="ps-vb-na">Sorry, this vanity can’t be configured right now.</p>'; return; }
        el.psVbHost.innerHTML=html;
        // relabel the builder's "Add to Cart" -> "Add to Project" (planner context only)
        $$(".vb-sidebar__atc-label", el.psVbHost).forEach(function(l){ l.textContent="Add to Project"; });
        activateScripts(el.psVbHost);
      })
      .catch(function(e){ console.error("[project-studio] vb load",e); el.psVbHost.innerHTML='<p class="ps-vb-na">Couldn’t load the builder. Please try again.</p>'; });
  }
  function closeVbView(){
    vbView=false;
    window.VB_PROJECT_ADD=null;
    el.psVbView.classList.remove("on");
    el.psVbHost.innerHTML="";   // tear down the builder instance + its DOM/listeners
    if(activeRoom()) showBoard(); else showStart();
  }

  /* pick a product (delegated) */
  function onPick(e){
    // configurable (ADP) vanity -> open the real Vanity Builder inline, don't add a snapshot
    var build=e.target.closest?e.target.closest("[data-build]"):null;
    if(build){ e.preventDefault(); openVbView(build.dataset.build, build.closest(".pc-pick")); return; }
    // multi-variant product -> open the options chooser instead of a blind first-variant add
    var view=e.target.closest?e.target.closest("[data-view]"):null;
    if(view){
      e.preventDefault();
      var vfs = e.currentTarget && e.currentTarget.id==="psSuggestRail";
      openVariantStep(view.closest(".pc-pick"), vfs?roomAccessorySlot(activeRoom()):picker.slot, vfs);
      return;
    }
    // only the explicit "Add to room" button adds — never a stray click on the card
    var btn=e.target.closest?e.target.closest("[data-pick]"):null;
    if(!btn) return;
    var n=btn.closest(".pc-pick"); if(!n) return;
    e.preventDefault();
    var snap={ handle:n.dataset.handle, title:n.dataset.title, brand:n.dataset.brand, price:parseInt(n.dataset.price,10)||0, compare:parseInt(n.dataset.compare,10)||0, img:n.dataset.img, finish:n.dataset.finish||"", family:n.dataset.family||"", vid:n.dataset.vid, url:n.dataset.url };
    // suggestion rail feeds the room's accessory slot (bathroom vs sink); the picker uses its own slot
    var fromSuggest = e.currentTarget && e.currentTarget.id==="psSuggestRail";
    var slot = fromSuggest ? roomAccessorySlot(activeRoom()) : picker.slot;
    if(!slot) return;
    addItem(slot, snap);
    if(!fromSuggest && el.psPicker.classList.contains("on")) closePicker();
    toast((snap.brand?snap.brand+" ":"")+(snap.title||"Item").split(",")[0]+" added");
  }

  /* ---------- cart ---------- */
  /* busy state for an action button (spinner + disabled), restorable */
  function setBtnBusy(btn, busy, busyLabel){
    if(!btn) return;
    if(busy){
      if(btn._busy) return; btn._busy=true; btn._origHTML=btn.innerHTML;
      btn.disabled=true; btn.classList.add("is-busy");
      btn.innerHTML='<span class="ps-btn-spin" aria-hidden="true"></span><span>'+(busyLabel||"Working")+'</span>';
    } else {
      if(!btn._busy) return; btn._busy=false;
      btn.disabled=false; btn.classList.remove("is-busy");
      if(btn._origHTML!=null){ btn.innerHTML=btn._origHTML; btn._origHTML=null; }
    }
  }
  function addToCart(items, label, btn){
    if(!items.length){ toast("Add a fixture first"); return; }
    var payload={ items: [] };
    items.forEach(function(i){
      if(i.vb && i.bundle && i.bundle.length){
        // configured vanity: replay the builder's exact bundle (vanity + basin + handle + P&W,
        // with their properties) so Cart Transform reprices it identically.
        i.bundle.forEach(function(b){ if(b&&b.id) payload.items.push({ id:parseInt(b.id,10), quantity:b.quantity||1, properties:b.properties||undefined }); });
      } else if(i.vid){
        payload.items.push({ id:parseInt(i.vid,10), quantity:(i.qty||1) });
      }
    });
    if(!payload.items.length){ toast("Couldn't add — missing variant info"); return; }
    // IMMEDIATE feedback: spin the button + slide the cart drawer in NOW, so the (sometimes slow)
    // add + full-cart re-render never looks frozen. The drawer shows its own progress bar while it
    // fetches; we refresh it again once the items have actually landed.
    setBtnBusy(btn, true, "Adding…");
    if(typeof window.openAtelierCart==="function") window.openAtelierCart();
    // ask /cart/add.js to ALSO return the re-rendered drawer in the same response (one round-trip
    // instead of two) - we then hand that HTML straight to the drawer, no second fetch.
    payload.sections = "atelier-cart"; payload.sections_url = location.pathname;
    fetch(CART_ADD, { method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"}, body:JSON.stringify(payload) })
      .then(function(r){ return r.json(); })
      .then(function(res){
        toast(label);
        var html = res && res.sections && res.sections["atelier-cart"];
        if(typeof window.openAtelierCart==="function") window.openAtelierCart(html || undefined);
      })
      .catch(function(e){ console.error("[project-studio] add to cart",e); toast("Couldn't add to cart — please try again"); })
      .finally(function(){ setBtnBusy(btn, false); });
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg){ el.psToastTx.innerHTML=msg; el.psToast.classList.add("on"); clearTimeout(toastT); toastT=setTimeout(function(){ el.psToast.classList.remove("on"); },2600); }

  /* ---------- scroll lock (compensate scrollbar width so content doesn't shift; mirrors atelier-cart) ---------- */
  function lockScroll(){ if(document.body.dataset.psLocked) return; var sw=window.innerWidth-document.documentElement.clientWidth; document.body.dataset.psLocked="1"; document.body.style.overflow="hidden"; if(sw>0) document.body.style.paddingRight=sw+"px"; }
  function unlockScroll(){ if(!document.body.dataset.psLocked) return; delete document.body.dataset.psLocked; document.body.style.overflow=""; document.body.style.paddingRight=""; }
  function syncScrollLock(){ if(psSheetOpen||el.psPicker.classList.contains("on")||el.psFstep.classList.contains("on")||el.psBrandStep.classList.contains("on")||(el.psVariantStep&&el.psVariantStep.classList.contains("on"))||el.psShareModal.classList.contains("on")||el.psEnquireModal.classList.contains("on")||(el.psConfirm&&el.psConfirm.classList.contains("on"))) lockScroll(); else unlockScroll(); }

  /* ---------- mobile summary sheet (the bottom bar expands into the full
     .ps-summary). Same element as the desktop sidebar, repositioned by CSS, so
     all its wiring (finish schedule / budget / totals / actions) keeps working.
     Locking sets body[data-ps-locked], which hides the slim bar via CSS. ---------- */
  var psSheetOpen=false;
  function openSheet(){
    if(psSheetOpen) return;
    psSheetOpen=true;
    document.body.classList.add("ps-sheet-open");
    if(el.psBarExpand) el.psBarExpand.setAttribute("aria-expanded","true");
    if(el.psSheetScrim) el.psSheetScrim.classList.add("on");
    syncScrollLock();
  }
  function closeSheet(){
    if(!psSheetOpen) return;
    psSheetOpen=false;
    document.body.classList.remove("ps-sheet-open");
    if(el.psBarExpand) el.psBarExpand.setAttribute("aria-expanded","false");
    if(el.psSheetScrim) el.psSheetScrim.classList.remove("on");
    syncScrollLock();
  }

  /* ---------- sticky summary offset = pinned header height (so it doesn't clip under the header) ---------- */
  function setStickyTop(){ var hdr=document.querySelector(".at-hdr"); var h=hdr?hdr.getBoundingClientRect().height:0; document.documentElement.style.setProperty("--ps-sticky-top",((h>0?h:116)+16)+"px"); }

  /* ---------- brand loader (Hex Wave + Pop) ---------- */
  function staggerLoader(svg){
    if(!svg) return;
    var tiles=$$(".bath > *", svg); if(!tiles.length) return;
    var xs=tiles.map(function(t){ try{ var b=t.getBBox(); return b.x+b.width/2; }catch(e){ return 0; } });
    var min=Math.min.apply(null,xs), max=Math.max.apply(null,xs), r=(max-min)||1;
    tiles.forEach(function(t,i){ t.style.animationDelay=(((xs[i]-min)/r)*0.65).toFixed(3)+"s"; });
  }
  function renderLoader(container, label){
    container.innerHTML='<div class="ps-loaderbox"><span class="ps-loader"></span>'+(label?'<span class="ps-loader-label">'+esc(label)+'</span>':'')+'</div>';
    var tpl=document.getElementById("psLoaderTpl");
    var holder=container.querySelector(".ps-loader");
    if(tpl && tpl.content.firstElementChild && holder){
      var svg=tpl.content.firstElementChild.cloneNode(true);
      holder.appendChild(svg);
      staggerLoader(svg); // svg is now in the (visible) DOM so getBBox works
    }
  }

  /* ============================================================
     SPEC SHEET — a clean, branded project document, shown as an
     on-screen A4 PREVIEW first (NOT auto-printed). The user reads it,
     then clicks "Print / Save as PDF" when ready. Self-contained
     window (no theme CSS to fight). Covers the WHOLE project.
     ============================================================ */
  var SPEC_CSS = "*{box-sizing:border-box;margin:0;padding:0}"
    +"html,body{background:#54585c}"
    +"body{font-family:'Helvetica Neue',Arial,sans-serif;color:#2c2e32;font-size:12px;line-height:1.5;padding:0 0 56px}"
    /* on-screen toolbar (hidden when printing) */
    +".bar{position:sticky;top:0;z-index:10;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;background:#1f2125;color:#fff;padding:11px 18px;box-shadow:0 2px 14px rgba(0,0,0,.35)}"
    +".bar .t{font-size:13px;font-weight:600;letter-spacing:.02em}.bar .t small{display:block;font-size:10.5px;font-weight:400;color:#b9bbbd;margin-top:1px}"
    +".bar .acts{display:flex;gap:9px}.bar button{font:inherit;font-size:12.5px;font-weight:600;border:0;border-radius:9px;padding:9px 16px;cursor:pointer}"
    +".bar .print{background:#c41230;color:#fff}.bar .print:hover{background:#9e0e26}"
    +".bar .close{background:transparent;color:#d4d5d7;border:1px solid rgba(255,255,255,.28)}.bar .close:hover{background:rgba(255,255,255,.1)}"
    /* the A4 sheet */
    +".sheet{width:210mm;min-height:297mm;margin:24px auto;background:#fff;padding:16mm;box-shadow:0 8px 36px rgba(0,0,0,.45)}"
    +".doc-h{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:2px solid #1f2125;padding-bottom:16px;margin-bottom:24px}"
    /* the logo lockup is a .at-logo-svg WRAPPER holding two overlapping svgs (bath +
       wordmark); this print doc has no theme CSS, so size the wrapper and overlap the
       inner svgs here. 198px = 40px * 1092.7/220.6 (the lockup aspect ratio). */
    +".doc-h .logo .at-logo-svg{position:relative;display:inline-block;width:198px;height:40px}"
    +".doc-h .logo .at-logo-svg svg{position:absolute;top:0;left:0;width:100%;height:100%}"
    +".doc-h .meta{text-align:right}.doc-h .meta .t{font-size:15px;font-weight:700;letter-spacing:.02em}.doc-h .meta .d{font-size:11px;color:#777;margin-top:3px}"
    +".room{margin-bottom:22px;page-break-inside:avoid}.rh{display:flex;align-items:baseline;gap:12px;border-bottom:1px solid #ddd;padding-bottom:6px;margin-bottom:6px}"
    +".rh h2{font-size:15px;font-weight:600}.rh .rf{font-size:11px;color:#9e0e26;font-weight:600}.rh .rt{margin-left:auto;font-size:13px;font-weight:700}"
    +"table{width:100%;border-collapse:collapse}th{text-align:left;font-size:9px;text-transform:uppercase;letter-spacing:.1em;color:#999;padding:5px 8px;border-bottom:1px solid #eee}"
    +"td{padding:7px 8px;border-bottom:1px solid #f1f1f1;vertical-align:middle}td.im{width:46px}td.im img{width:40px;height:40px;object-fit:contain}"
    +"td.slot{font-size:9.5px;text-transform:uppercase;letter-spacing:.05em;color:#888;width:92px}"
    +"td.nm .bd{display:block;font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:#9e0e26;font-weight:700}"
    +"td.nm .nt{display:block;font-size:10px;font-style:italic;color:#666;margin-top:2px}"
    +"td.fin{width:120px;color:#555}td.qty,th.qty{width:46px;text-align:center}td.pr{text-align:right;font-weight:700;width:92px;white-space:nowrap}"
    +".grand{display:flex;justify-content:flex-end;align-items:baseline;gap:18px;border-top:2px solid #1f2125;margin-top:6px;padding-top:12px}.grand span{font-size:12px;font-weight:600}.grand b{font-size:21px}"
    +"footer{margin-top:26px}"
    +".disc-box{border:1px solid #e7c4ca;border-left:4px solid #c41230;background:#fdf3f4;border-radius:6px;padding:13px 15px;-webkit-print-color-adjust:exact;print-color-adjust:exact}"
    +".disc-title{font-size:11.5px;font-weight:700;color:#9e0e26;margin-bottom:5px;letter-spacing:.01em}"
    +".disc{font-size:10px;color:#3a3a3a;line-height:1.65}.disc b{color:#9e0e26;font-weight:700}"
    +".disc-gen{font-size:9px;color:#9a9a9a;line-height:1.6;margin-top:11px;text-align:center}"
    /* print: drop the grey backdrop + toolbar, let the browser paginate with real A4 margins */
    +"@page{size:A4;margin:16mm}"
    +"@media print{html,body{background:#fff}body{padding:0}.bar{display:none}.sheet{width:auto;min-height:0;margin:0;padding:0;box-shadow:none}}";
  function specSheetHTML(){
    var tpl=document.getElementById("psLogoTpl");
    var logo=(tpl&&tpl.content&&tpl.content.firstElementChild)?tpl.content.firstElementChild.outerHTML
      :'<div style="font-size:18px;font-weight:700;letter-spacing:.02em">Bathroom Sales Direct</div>';
    var dateStr; try{ dateStr=new Date().toLocaleDateString("en-AU",{day:"numeric",month:"long",year:"numeric"}); }catch(e){ dateStr=""; }
    var grand=0, roomsHtml="";
    project.rooms.forEach(function(r){
      if(!r.items.length) return;
      var sub=0;
      var rows=r.items.map(function(it){
        var q=it.qty||1, line=(it.price||0)*q; sub+=line;
        var sd=SLOTS[it.slot]||{label:"",fin:false};
        var finCell=it.vb?esc(it.config||"Configured"):((sd.fin&&it.finish)?esc(it.finish):"—");
        return '<tr><td class="im">'+(it.img?'<img src="'+esc(it.img)+'" alt="">':'')+'</td>'
          +'<td class="slot">'+esc(sd.label||"")+'</td>'
          +'<td class="nm">'+(it.brand?'<span class="bd">'+esc(it.brand)+'</span>':'')+esc(it.title||"")+(it.note?'<span class="nt">Note: '+esc(it.note)+'</span>':'')+'</td>'
          +'<td class="fin">'+finCell+'</td>'
          +'<td class="qty">'+q+'</td>'
          +'<td class="pr">'+moneyExact(line)+'</td></tr>';
      }).join("");
      grand+=sub;
      var bnote="";
      if(r.budget){ var bover=sub>r.budget;
        bnote='<span style="display:block;width:100%;margin-top:4px;font-size:11px;color:'+(bover?"#b07b3f":"#1c7a4a")+'">Budget '+moneyExact(r.budget)+' &middot; '+(bover?moneyExact(sub-r.budget)+" over":moneyExact(r.budget-sub)+" under")+'</span>'; }
      roomsHtml+='<section class="room"><div class="rh"><h2>'+esc(r.name)+'</h2>'
        +(r.finish?'<span class="rf">'+esc(r.finish)+' finish</span>':'')
        +'<span class="rt">'+moneyExact(sub)+'</span>'+bnote+'</div>'
        +'<table><thead><tr><th></th><th>Fixture</th><th>Product</th><th>Finish</th><th class="qty">Qty</th><th>Price</th></tr></thead><tbody>'+rows+'</tbody></table></section>';
    });
    return '<!doctype html><html lang="en"><head><meta charset="utf-8">'
      +'<title>Project specification — Bathroom Sales Direct</title><style>'+SPEC_CSS+'</style></head><body>'
      +'<div class="bar"><span class="t">Project specification<small>Use “Save as PDF” in the print dialog to download a copy.</small></span>'
      +'<div class="acts"><button class="print" type="button" onclick="window.print()">Print / Save as PDF</button>'
      +'<button class="close" type="button" onclick="window.close()">Close</button></div></div>'
      +'<div class="sheet">'
      +'<header class="doc-h"><div class="logo">'+logo+'</div>'
      +'<div class="meta"><div class="t">Project specification</div><div class="d">'+dateStr+'</div></div></header>'
      +roomsHtml
      +'<div class="grand"><span>Project total</span><b>'+moneyExact(grand)+'</b></div>'
      +'<footer>'
      +'<div class="disc-box">'
      +'<p class="disc-title">This is a planning summary — not an official quote.</p>'
      +'<p class="disc">Prices shown are <b>indicative only</b> and <b>exclude delivery</b>. They are <b>subject to change</b> and to <b>stock availability</b>, and are not confirmed until checkout. For a firm, up-to-date quote, please <b>contact our team</b>.</p>'
      +'</div>'
      +'<p class="disc-gen">Generated from the project planner at bathroomsalesdirect.com.au.</p>'
      +'</footer>'
      +'</div></body></html>';
  }
  function openSpec(){ closeSheet();
    var has=project.rooms.some(function(r){ return r.items.length; });
    if(!has){ toast("Add some items first"); return; }
    var w=window.open("","_blank");
    if(!w){ toast("Allow pop-ups to view your spec sheet"); return; }
    w.document.open(); w.document.write(specSheetHTML()); w.document.close(); w.focus();
  }

  /* ============================================================
     SHARE — encode project into a #fragment link (no backend).
     Self-contained snapshot; recipient previews (never auto-saved)
     then chooses Add / Replace / Discard. family is recomputed on
     decode; product url rebuilt from handle, to keep links short.
     ============================================================ */
  function b64urlEncode(str){ return btoa(unescape(encodeURIComponent(str))).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,""); }
  function b64urlDecode(s){ s=s.replace(/-/g,"+").replace(/_/g,"/"); while(s.length%4) s+="="; return decodeURIComponent(escape(atob(s))); }
  /* link payload = only the un-refetchable bits: slot, handle, variant id, brand + finish
     (both metafield-derived). title/price/image are re-fetched from /products/<handle>.js on
     open — keeps links short AND prices current. */
  /* link payload = only { slot, handle } per item. Everything else (title, price, image,
     brand, finish, variant id) is resolved from the handle on open via the
     atelier-project-item section — the shortest a backend-free link can be. */
  /* byte <-> base64url for compressed payloads */
  function bytesToB64url(u8){ var s=""; for(var i=0;i<u8.length;i++) s+=String.fromCharCode(u8[i]); return btoa(s).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,""); }
  function b64urlToBytes(b64){ b64=b64.replace(/-/g,"+").replace(/_/g,"/"); while(b64.length%4) b64+="="; var bin=atob(b64), u8=new Uint8Array(bin.length); for(var i=0;i<bin.length;i++) u8[i]=bin.charCodeAt(i); return u8; }
  /* compress via the browser-native CompressionStream (no library). Falls back to plain base64.
     key 'pz' = deflate-raw + base64url ; 'p' = base64url only. Returns a Promise. */
  function compressToParam(str){
    if(typeof CompressionStream!=="undefined" && typeof Blob!=="undefined" && typeof TextEncoder!=="undefined"){
      try{
        var cs=new CompressionStream("deflate-raw");
        var stream=new Blob([new TextEncoder().encode(str)]).stream().pipeThrough(cs);
        return new Response(stream).arrayBuffer()
          .then(function(buf){ return { key:"pz", val:bytesToB64url(new Uint8Array(buf)) }; })
          .catch(function(){ return { key:"p", val:b64urlEncode(str) }; });
      }catch(e){}
    }
    return Promise.resolve({ key:"p", val:b64urlEncode(str) });
  }
  function decompressParam(key,val){
    if(key==="pz"){
      try{
        var ds=new DecompressionStream("deflate-raw");
        var stream=new Blob([b64urlToBytes(val)]).stream().pipeThrough(ds);
        return new Response(stream).arrayBuffer().then(function(buf){ return new TextDecoder().decode(buf); });
      }catch(e){ return Promise.reject(e); }
    }
    return Promise.resolve(b64urlDecode(val));
  }
  /* compact payload: only slot+handle per item (+ room type/name/finish) */
  function buildPayload(p){
    return { v:1, r:(p.rooms||[]).map(function(rm){
      var o={ t:rm.type, n:rm.name, f:rm.finish||null, i:(rm.items||[]).map(function(it){
        var sc=SLOT_CODES.indexOf(it.slot), o={ s: sc>=0?sc:it.slot };
        if(it.vb){
          // configured vanity: carry the un-derivable bits (bundle + configured price + config
          // summary); title/brand/image are re-resolved from the base handle on open.
          o.vb=1; o.h=it.handle||""; o.p=it.price||0; o.cfg=it.config||"";
          o.bn=(it.bundle||[]).map(function(b){ var x={ id:b.id }; if((b.quantity||1)!==1) x.q=b.quantity; if(b.properties) x.pr=b.properties; return x; });
        } else {
          o.h=it.handle;
          // a chosen non-default variant - carry id/price/label so a shared link keeps the exact
          // option (handle-only resolution would otherwise revert to the default variant).
          if(it.variant && it.vid){ o.vid=it.vid; o.p=it.price||0; o.vn=it.variant; }
        }
        if((it.qty||1)>1) o.q=it.qty;
        return o;
      }) };
      if(rm.budget) o.b=rm.budget; if(rm.brand) o.br=rm.brand; return o;
    })};
  }
  function payloadToProject(pl){
    if(!pl||!pl.r||!pl.r.length) return null;
    return { active:0, rooms:pl.r.map(function(rm){
      return { type:rm.t||"ensuite", name:rm.n||"Room", finish:rm.f||null, budget:rm.b||null, brand:rm.br||null, items:(rm.i||[]).map(function(it){
        var slot = (typeof it.s==="number" ? SLOT_CODES[it.s] : it.s) || it.s;
        if(it.vb){
          var bundle=(it.bn||[]).map(function(x){ return { id:x.id, quantity:x.q||1, properties:x.pr||null }; });
          return { slot:slot, vb:true, qty:it.q||1, handle:it.h||"", title:"", brand:"", img:"", price:it.p||0, compare:0, finish:"", family:"", config:it.cfg||"Configured to order", bundle:bundle, vid:null, url:it.h?("/products/"+it.h):"" };
        }
        return { slot:slot, handle:it.h, qty:it.q||1, vid:it.vid||null, variant:it.vn||"", brand:"", title:it.h||"", finish:"", family:"", price:it.p||0, compare:0, img:"", url:it.h?("/products/"+it.h):"" };
      })};
    })};
  }
  /* read + decode a shared project from the URL hash (#pz= compressed, #p= raw) -> project|null */
  function readSharedFromHash(){
    var m=(location.hash||"").match(/[#&](pz|p)=([^&]+)/);
    if(!m) return Promise.resolve(null);
    return decompressParam(m[1], m[2])
      .then(function(json){ try{ return payloadToProject(JSON.parse(json)); }catch(e){ return null; } })
      .catch(function(){ return null; });
  }
  /* resolve each item from its handle via the project-item section (gives metafield brand+finish
     too). Drops products that no longer exist. */
  function hydrateShared(sp){
    var handles={}; sp.rooms.forEach(function(rm){ (rm.items||[]).forEach(function(it){ if(it.handle) handles[it.handle]=1; }); });
    var list=Object.keys(handles);
    if(!list.length) return Promise.resolve(sp);
    return Promise.all(list.map(function(h){
      return fetch(ROOT+"products/"+encodeURIComponent(h)+"?section_id=atelier-project-item",{headers:{Accept:"text/html"}})
        .then(function(r){ return r.ok?r.text():null; }).catch(function(){ return null; })
        .then(function(html){
          if(!html) return {h:h,d:null};
          try{ var doc=new DOMParser().parseFromString(html,"text/html"); var node=doc.getElementById("psItemData"); return {h:h, d:node?JSON.parse(node.textContent):null}; }
          catch(e){ return {h:h,d:null}; }
        });
    })).then(function(res){
      var map={}; res.forEach(function(x){ map[x.h]=x.d; });
      sp.rooms.forEach(function(rm){
        rm.items=(rm.items||[]).filter(function(it){
          if(it.vb){
            if(!it.bundle || !it.bundle.length) return false;     // a configured vanity needs its bundle to be usable
            var dv=map[it.handle];                                // base vanity -> display bits that stay current
            it.title = (dv&&dv.title) || it.title || "Configured vanity";
            it.brand = (dv&&dv.brand) || it.brand || "";
            it.img   = (dv&&dv.img)   || it.img   || "";
            return true;
          }
          var d=map[it.handle]; if(!d || !d.vid) return false;   // product gone -> drop
          it.title=d.title||it.handle; it.brand=d.brand||""; it.finish=d.finish||""; it.family=d.family||family(it.finish); it.families=d.families||it.family;
          // prefer a carried variant (multi-variant pick); else the product's default variant
          it.vid=it.vid||d.vid; it.price=it.price||d.price||0; it.compare=d.compare||0; it.img=d.img||"";
          return true;
        });
      });
      return sp;
    });
  }
  function copyText(text){
    if(navigator.clipboard && navigator.clipboard.writeText){ return navigator.clipboard.writeText(text); }
    return new Promise(function(res,rej){
      try{ var ta=document.createElement("textarea"); ta.value=text; ta.style.position="fixed"; ta.style.opacity="0"; document.body.appendChild(ta); ta.focus(); ta.select(); document.execCommand("copy"); document.body.removeChild(ta); res(); }catch(e){ rej(e); }
    });
  }
  function openShareModal(){ closeSheet();
    var has = project.rooms.some(function(r){ return r.items.length; });
    if(!has){ toast("Add some items first"); return; }
    noteSaved();   // engaging with save/share means they know how to keep a copy -> stop nudging
    el.psShareCopy.classList.remove("done"); el.psShareCopy.textContent="Copy link";
    el.psShareLink.value="Generating link…"; el.psShareLink.removeAttribute("data-link");
    el.psShareModal.classList.add("on"); syncScrollLock();
    compressToParam(JSON.stringify(buildPayload(project))).then(function(enc){
      var link = location.origin + location.pathname + "#" + enc.key + "=" + enc.val;
      el.psShareLink.value=link; el.psShareLink.setAttribute("data-link", link);
      var msg="Here's my bathroom project plan: ";
      el.psShareWa.href="https://wa.me/?text="+encodeURIComponent(msg+link);
    });
  }
  function closeShareModal(){ el.psShareModal.classList.remove("on"); syncScrollLock(); }
  /* "Email it to me" - reliable, never a dead click:
     - native share sheet where available (mobile + modern desktop) -> includes Mail/Gmail
     - otherwise copy the link to the clipboard (so they always have it) AND best-effort open
       the mail app via mailto. Never silently does nothing. */
  function emailProject(){
    var link = el.psShareLink.getAttribute("data-link"); if(!link) return;
    noteSaved();
    if(navigator.share){
      navigator.share({ title:"My bathroom project", text:"Here's my bathroom project plan", url:link }).catch(function(){});
      return;
    }
    copyText(link).then(function(){ toast("Link copied — opening your email app. If it doesn't open, just paste the link into an email."); })
      .catch(function(){ toast("Link copied — paste it into an email to yourself."); });
    try{ location.href = "mailto:?subject="+encodeURIComponent("My bathroom project")+"&body="+encodeURIComponent("Here's my bathroom project plan: "+link); }catch(e){}
  }

  /* ----- enquire (submits via Shopify's native contact form -> store contact email) ----- */
  function openEnquireModal(){ closeSheet();
    var has = project.rooms.some(function(r){ return r.items.length; });
    if(!has){ toast("Add some items first"); return; }
    el.psEnqBody.style.display=""; el.psEnqDone.style.display="none";
    el.psEnqErr.classList.remove("on"); el.psEnqErr.textContent="";
    $$(".err", el.psEnqForm).forEach(function(x){ x.classList.remove("err"); });
    el.psEnquireModal.classList.add("on"); syncScrollLock();
    setTimeout(function(){ try{ el.psEnqName.focus(); }catch(e){} }, 140);
  }
  function closeEnquireModal(){ el.psEnquireModal.classList.remove("on"); syncScrollLock(); }
  function enqError(msg){ el.psEnqErr.textContent = msg; el.psEnqErr.classList.add("on"); }
  function submitEnquiry(e){
    e.preventDefault();
    var name=el.psEnqName.value.trim(), email=el.psEnqEmail.value.trim(), phone=el.psEnqPhone.value.trim(), msg=el.psEnqMsg.value.trim();
    var emailOk=/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
    el.psEnqName.parentNode.classList.toggle("err", !name);
    el.psEnqEmail.parentNode.classList.toggle("err", !emailOk);
    if(!name || !emailOk){ el.psEnqErr.textContent = !name ? "Please add your name." : "Please enter a valid email address."; el.psEnqErr.classList.add("on"); return; }
    el.psEnqErr.classList.remove("on");
    el.psEnqSend.disabled=true; var lbl=el.psEnqSend.innerHTML; el.psEnqSend.textContent="Sending…";
    compressToParam(JSON.stringify(buildPayload(project))).then(function(enc){
      var link=location.origin+location.pathname+"#"+enc.key+"="+enc.val;
      var grand=0, lines=[];
      project.rooms.forEach(function(r){
        if(!r.items.length) return;
        var sub=0; r.items.forEach(function(it){ sub+=(it.price||0)*(it.qty||1); }); grand+=sub;
        lines.push(r.name+(r.finish?" ("+r.finish+")":"")+": "+r.items.length+" item"+(r.items.length===1?"":"s")+", "+money(sub)
          +(r.budget?(" — budget "+money(r.budget)+", "+(sub>r.budget?money(sub-r.budget)+" over":money(r.budget-sub)+" under")):""));
        r.items.forEach(function(it){ var q=it.qty||1; var tag=it.vb?(" ["+(it.config||"configured")+"]"):(it.finish?(" ["+it.finish+"]"):""); lines.push("   - "+(q>1?q+"x ":"")+(it.brand?it.brand+" ":"")+it.title+tag+" - "+money((it.price||0)*q)+(it.note?("\n       note: "+it.note):"")); });
      });
      var body = (msg?msg+"\n\n":"") + "— MY PROJECT —\n" + lines.join("\n") + "\n\nProject total: "+money(grand) + "\n\nView the full project: " + link;
      var fd = new URLSearchParams();
      fd.append("form_type","contact"); fd.append("utf8","✓");
      fd.append("contact[name]", name);
      fd.append("contact[email]", email);
      if(phone) fd.append("contact[phone]", phone);
      fd.append("contact[body]", body);
      fetch(ROOT+"contact", { method:"POST", headers:{ "Accept":"text/html" }, body:fd })
        .then(function(r){ return r.text().then(function(html){ return { ok:r.ok, url:r.url||"", html:html }; }); })
        .then(function(res){
          el.psEnqSend.disabled=false; el.psEnqSend.innerHTML=lbl;
          var success = res.ok && (res.url.indexOf("contact_posted=true")>=0 || /posted_successfully|been sent|thank/i.test(res.html));
          if(success){
            el.psEnqDoneMsg.textContent = "Thanks "+name.split(" ")[0]+" — we've got your project and we'll be in touch shortly.";
            el.psEnqBody.style.display="none"; el.psEnqDone.style.display="block";
          } else {
            enqError("Sorry — that didn't send. Please try again in a moment.");
          }
        })
        .catch(function(){ el.psEnqSend.disabled=false; el.psEnqSend.innerHTML=lbl; enqError("Network error — please try again."); });
    });
  }

  /* ----- shared-view flow (recipient) ----- */
  var sharedPreview = null;   // the shared project being previewed (not in the workspace)
  function enterShared(sp){
    load();                                   // load the visitor's OWN workspace from storage
    sharedMode = true; sharedPreview = sp; project = sp; project.active = 0; // preview (save() no-ops; workspace untouched)
    el.psStart.classList.remove("on"); el.psBoard.classList.add("on");
    el.psSharedBar.style.display = "flex";
    if(el.psProjbar) el.psProjbar.style.display = "none";   // hide the project switcher while previewing
    el.psRoomName.textContent = (sp.rooms[0] && sp.rooms[0].name) || "Shared project";
    renderLoader(el.psSlots, "Loading shared project…");
    hydrateShared(sp).then(function(){ if(project.active>=project.rooms.length) project.active=0; wantSlotsEnter=true; render(); });
  }
  function exitShared(){
    sharedMode = false; sharedPreview = null; el.psSharedBar.style.display = "none";
    if(el.psProjbar) el.psProjbar.style.display = "";
    if(history.replaceState) history.replaceState(null, "", location.pathname + location.search);
  }
  /* Add the shared rooms as a brand-new project (cleanest with multiple projects -
     never touches the visitor's existing projects). */
  function mergeShared(){
    var sp = sharedPreview || project;
    var np = blankProject((sp.rooms[0] && sp.rooms[0].name ? sp.rooms[0].name : "Shared") + " project");
    (sp.rooms||[]).forEach(function(rm){
      np.rooms.push({ type:rm.type, name:rm.name, finish:rm.finish||null, budget:rm.budget||null, brand:rm.brand||null, items:(rm.items||[]).slice() });
    });
    np.active = 0;
    workspace.projects.push(np); workspace.active = workspace.projects.length-1; project = np;
    exitShared(); save(); render();
    toast("Saved as a new project");
  }
  /* Replace the CURRENT project's contents with the shared one (keeps its name/slot). */
  function replaceShared(){
    var sp = sharedPreview || project;
    var cur = activeProject();
    cur.rooms = (sp.rooms||[]).map(function(rm){ return { type:rm.type, name:rm.name, finish:rm.finish||null, budget:rm.budget||null, brand:rm.brand||null, items:(rm.items||[]).slice() }; });
    cur.active = 0; project = cur;
    exitShared(); save(); render();
    toast("This project was replaced");
  }
  function discardShared(){
    project = activeProject();
    exitShared();
    if(project.rooms.length){ showBoard(); } else { showStart(); }
    updateBadge();
  }

  /* ---------- boot ---------- */
  function boot(){
    ref();
    if(!el.psStart) return; // section not on page
    // ask the browser to keep our localStorage out of routine eviction (best-effort; doesn't
    // stop a manual clear or iOS's 7-day cap, but cheap hardening for saved projects)
    try{ if(navigator.storage && navigator.storage.persist) navigator.storage.persist(); }catch(e){}
    buildStart();
    // static listeners
    el.psPkClose.addEventListener("click", closePicker);
    el.psScrim.addEventListener("click", closePicker);
    if(el.psBudgetAdd) el.psBudgetAdd.addEventListener("click", openBudgetEditor);
    if(el.psBudgetEdit) el.psBudgetEdit.addEventListener("click", openBudgetEditor);
    if(el.psProjMenuBtn) el.psProjMenuBtn.addEventListener("click", function(e){ e.stopPropagation(); toggleProjMenu(); });
    if(el.psProjRename) el.psProjRename.addEventListener("click", startProjectRename);
    if(el.psProjNew) el.psProjNew.addEventListener("click", newProject);
    if(el.psProjSave) el.psProjSave.addEventListener("click", openShareModal);
    if(el.psProjMenuSave) el.psProjMenuSave.addEventListener("click", function(){ closeProjMenu(); openShareModal(); });
    if(el.psSaveTipGo) el.psSaveTipGo.addEventListener("click", openShareModal);
    if(el.psSaveTipX) el.psSaveTipX.addEventListener("click", noteSaved);
    if(el.psProjMenu) el.psProjMenu.addEventListener("click", function(e){ e.stopPropagation(); });
    document.addEventListener("click", function(){ if(el.psProjMenu && !el.psProjMenu.hidden) closeProjMenu(); });
    if(el.psRbrandBtn) el.psRbrandBtn.addEventListener("click", openBrandStep);
    if(el.psBrandSearch) el.psBrandSearch.addEventListener("input", function(){ buildBrandGrid(el.psBrandSearch.value); });
    if(el.psBrandGo) el.psBrandGo.addEventListener("click", function(){ confirmBrand(false); });
    if(el.psBrandSkip) el.psBrandSkip.addEventListener("click", function(){ confirmBrand(true); });
    if(el.psBrandStep) el.psBrandStep.addEventListener("click", function(e){ if(e.target===el.psBrandStep) closeBrandStep(); });
    el.psPkSearch.addEventListener("input", applyPickerFilter);
    el.psPkCoordTog.addEventListener("click", function(){ picker.coordOn=!picker.coordOn; setCoordBanner(picker.dom, picker.coordOn); applyPickerFilter(); });
    el.psPkGrid.addEventListener("click", onPick);
    if(el.psPkView) el.psPkView.addEventListener("click", function(e){ var b=e.target.closest("[data-pkview]"); if(b) setPkView(b.dataset.pkview); });
    el.psSuggestRail.addEventListener("click", onPick);
    el.psFstepGo.addEventListener("click", function(){ confirmFstep(false); });
    el.psFstepSkip.addEventListener("click", function(){ confirmFstep(true); });
    if(el.psVstepGo) el.psVstepGo.addEventListener("click", confirmVariantStep);
    if(el.psVstepCancel) el.psVstepCancel.addEventListener("click", closeVariantStep);
    if(el.psVariantStep) el.psVariantStep.addEventListener("click", function(e){ if(e.target===el.psVariantStep) closeVariantStep(); });
    el.psRfinBtn.addEventListener("click", function(){ var r=activeRoom(); if(r) openFinishStep(r.type,"change"); });
    el.psRenameBtn.addEventListener("click", startRename);
    el.psDupBtn.addEventListener("click", function(){ duplicateRoom(project.active); });
    // delete room - two-click confirm (no browser dialog)
    var delArmed=false, delT;
    function resetDel(){ delArmed=false; if(el.psDelBtn){ el.psDelBtn.classList.remove("danger"); el.psDelBtn.title="Delete room"; } clearTimeout(delT); }
    el.psDelBtn.addEventListener("click", function(){
      if(!delArmed){ delArmed=true; el.psDelBtn.classList.add("danger"); el.psDelBtn.title="Click again to delete this room"; clearTimeout(delT); delT=setTimeout(resetDel,3000); return; }
      resetDel(); deleteRoom(project.active);
    });
    // start over - hard confirm modal (wipes the whole project)
    el.psStartOver.addEventListener("click", function(){
      var nm = activeProject() ? activeProject().name : "this project";
      openConfirm({
        title:"Start over?",
        msg:"This permanently clears “"+nm+"” — every room and item will be removed, and it can’t be undone. If you might want it later, copy or email yourself the link first.",
        confirm:"Yes, clear everything",
        onConfirm: clearProject
      });
    });
    if(el.psConfirmCancel) el.psConfirmCancel.addEventListener("click", closeConfirm);
    if(el.psConfirmGo) el.psConfirmGo.addEventListener("click", function(){ var cb=confirmCb; closeConfirm(); if(typeof cb==="function") cb(); });
    if(el.psConfirm) el.psConfirm.addEventListener("click", function(e){ if(e.target===el.psConfirm) closeConfirm(); });
    el.psSpec.addEventListener("click", openSpec);
    el.psVbBack.addEventListener("click", closeVbView);
    el.psAddRoom.addEventListener("click", function(){ var r=activeRoom(); addToCart(r.items, "<b>"+esc(r.name)+"</b> added to cart", this); });
    if(el.psBarAdd) el.psBarAdd.addEventListener("click", function(){ var r=activeRoom(); if(r) addToCart(r.items, "<b>"+esc(r.name)+"</b> added to cart", this); });
    if(el.psBarExpand) el.psBarExpand.addEventListener("click", function(){ psSheetOpen?closeSheet():openSheet(); });
    if(el.psSheetScrim) el.psSheetScrim.addEventListener("click", closeSheet);
    if(el.psSheetClose) el.psSheetClose.addEventListener("click", closeSheet);
    el.psAddAll.addEventListener("click", function(){ var all=[]; project.rooms.forEach(function(r){ all=all.concat(r.items); }); addToCart(all, "Whole project added to cart", this); });
    el.psEnquire.addEventListener("click", openEnquireModal);
    el.psEnqX.addEventListener("click", closeEnquireModal);
    el.psEnquireModal.addEventListener("click", function(e){ if(e.target===el.psEnquireModal) closeEnquireModal(); });
    el.psEnqForm.addEventListener("submit", submitEnquiry);
    el.psEnqDoneClose.addEventListener("click", closeEnquireModal);
    el.psShare.addEventListener("click", openShareModal);
    el.psShareX.addEventListener("click", closeShareModal);
    el.psShareModal.addEventListener("click", function(e){ if(e.target===el.psShareModal) closeShareModal(); });
    el.psShareCopy.addEventListener("click", function(){
      var link = el.psShareLink.getAttribute("data-link") || el.psShareLink.value;
      copyText(link).then(function(){
        el.psShareCopy.textContent="Copied"; el.psShareCopy.classList.add("done");
        try{ el.psShareLink.select(); }catch(e){}
        setTimeout(function(){ el.psShareCopy.textContent="Copy link"; el.psShareCopy.classList.remove("done"); },2000);
      }).catch(function(){ try{ el.psShareLink.select(); }catch(e){} toast("Press Ctrl+C to copy"); });
    });
    if(el.psShareEmail) el.psShareEmail.addEventListener("click", emailProject);
    el.psSharedAdd.addEventListener("click", mergeShared);
    el.psSharedDiscard.addEventListener("click", discardShared);
    var replaceArmed=false, replaceT;
    el.psSharedReplace.addEventListener("click", function(){
      if(!replaceArmed){ replaceArmed=true; el.psSharedReplace.textContent="Confirm replace"; el.psSharedReplace.classList.add("danger"); clearTimeout(replaceT); replaceT=setTimeout(function(){ replaceArmed=false; el.psSharedReplace.textContent="Replace this project"; el.psSharedReplace.classList.remove("danger"); },3500); return; }
      replaceShared();
    });
    document.addEventListener("keydown", function(e){ if(e.key==="Escape"){ if(el.psConfirm && el.psConfirm.classList.contains("on")) closeConfirm(); else if(el.psEnquireModal.classList.contains("on")) closeEnquireModal(); else if(el.psShareModal.classList.contains("on")) closeShareModal(); else if(el.psBrandStep.classList.contains("on")) closeBrandStep(); else if(el.psFstep.classList.contains("on")) confirmFstep(true); else if(el.psPicker.classList.contains("on")) closePicker(); else if(el.psProjMenu && !el.psProjMenu.hidden) closeProjMenu(); else if(psSheetOpen) closeSheet(); } });
    // sticky-offset under the pinned header
    setStickyTop();
    window.addEventListener("resize", setStickyTop);
    window.addEventListener("load", setStickyTop);
    // shared link? (#pz= compressed / #p= raw) -> preview without ever overwriting their own project
    readSharedFromHash().then(function(sp){
      if(sp){ enterShared(sp); }
      else { load(); if(project.rooms.length){ showBoard(); } else { showStart(); } updateBadge(); }
    });
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
